const languageObj = {
  ra: {
    action: {
      send: 'Enviar',
      back_to_list: 'Volver al listado',
      clear: 'Limpiar',
      delete: 'Borrar',
      eliminate: 'Eliminar',
      list: 'Listar',
      save: 'Guardar',
      create: 'Crear',
      edit: 'Editar',
      sort: 'Ordenar',
      cancel: 'Cancelar',
      issuance: 'Reembolsar',
      undo: 'Deshacer',
      refresh: 'Refrescar',
      add: 'Agregar',
      remove: 'Remover',
      add_filter: 'Agregar filtro',
      remove_filter: 'Remover filtro',
      back: 'Regresar',
      bulk_actions: '%{smart_count} seleccionado',
      export: 'Exportar',
      import: 'Importar',
      unselect: 'Desmarcar',
      confirm: 'Confirmado',
      add_specific: 'Agregar %{name}',
      clear_input_value: 'Limpiar valor de formulario',
      enable: 'Habilitar',
      disable: 'Deshabilitar',
      actions: 'Acciones',
      generate_payment: 'Generar pago',
      search: 'Buscar',
      remove_all_filters: 'Eliminar todos los filtros',
      go_payment_types: 'Ir a formas de pago',
      pay: 'Pagar',
      to_confirm: 'Confirmar',
      test_rule: 'Testear Regla',
      see_details: 'Ver detalles',
      go_revision: 'revisiones',
      clone: 'Clonar %{name}',
      generate: 'Generar',
      generate_receipts: 'Generar recibos',
      generate_receipt: 'Generar recibo',
      generated: 'Generado',
      acept: 'Aceptar',
      emit: 'Emitir',
      emit_status: 'Emitido',
      cancel_status: 'Cancelado',
      reimburse: 'Reembolsar',
      close: 'Cerrar',
      see_conditions: 'Ver condiciones',
      see_conditions_provider: 'Ver condiciones proveedor',
      save_and_calculate_liquidation: 'Guardar y calcular liquidación',
      save_and_recalculate_liquidation: 'Guardar y recalcular liquidación',
      refresh_date: 'Actualizar datos',
      calculate_liquidation: 'Calcular liquidación',
      save_and_back_to_list: 'Guardar e ir al listado',
      create_reservation: 'Crear nueva reserva',
      guarantee: 'Garantizar',
      move: 'Mover',
      apply_to_reservation: 'Aplicar a reserva',
      apply_to_item: 'Aplicar a items',
      finish_and_generate_receipt: 'Finalizar y generar recibo',
      finish_without_generate_receipt: 'Finalizar sin generar recibo',
      change_password: 'Cambiar contraseña',
      update: 'Actualizar',
      see_something: 'Ver %{thing}',
      forward: 'Reenviar',
      forward_something: 'Reenviar a %{something}',
      continue: 'Continuar',
      regenerate_notification: 'Regenerar notificación',
      update_all_products: 'Actualizar todos los productos',
      add_file: 'Agregar archivo',
      initCompleteProcess: 'Iniciar Proceso Completo',
      initProcess: 'Iniciar proceso',
      preview: 'Previsualizar',
      update_rule_view: 'Actualizar vista',
      finish: 'Finalizar',
      details: 'Detalles',
      split: 'Separar',
      pay_with: 'Pagar con %{name}',
      void: 'Voidear',
      select: 'Seleccionar',
      select_with_dots: 'Seleccionar...',
      loading: 'Cargando...',
      show: 'Ver',
      filter: 'Filtrar',
      approve: 'Aprobar',
      refuse: 'Rechazar',
      delete_business_in_tma: 'Anular negocio en TMA',
      hidden: 'Ocultar',
      addPaymentRecord: 'Agregar registro de pago',
      addAnotherPaymentRecord: 'Agregar otro registro de pago',
      addNewRetention: 'Agregar nueva retención',
      removeRetention: 'Quitar retención',
      deleteRecord: 'Eliminar registro',
      addMoreReservations: 'Agregar más reservas',
      addReservations: 'Agregar reservas',
      registerPayment: 'Registrar pago',
      allocatePaymentToReservations: 'Imputar pago de las reservas',
      searchReservations: 'Buscar reservas',
      downloadHistory: 'Descargar Histórico',
      download: 'Descargar',
      addNewRelation: 'Agregar una nueva relación',
      addComponent: 'Agregar componente',
      uploadAndReconcileStatement: 'Subir y conciliar extracto',
      generateAndDownloadStatement: 'Generar y descargar extracto',
      view_reservation: 'Ver reserva',
      add_comment : 'Agregar comentario',
      unapply_payment: 'Desaplicar pago',
      after_sales : 'Postventa',
      show_aftersales: 'Mostrar item postventa',
      hide_aftersales: 'Ocultar item postventa',
      register_return: 'Registrar devolución',
      view_retail_liquidation: 'Ver liquidación minorista',
      new_message:'Nuevo mensaje',
      clear:'Limpiar',
      send:'Enviar',
      added: 'añadió',
      wrote: 'escribió',
      download:'Descargar',
      view_history: 'Ver historial',
      general_search:'Búsqueda general',
      reply:'Responder',
      return:'Devolver',
      see_more:'Ver más...',
      see_less:'Ver menos',
      generate_credit: 'Generar crédito',
      add_reservation:'Agregar reserva',
      add_payment_instance: 'Agregar instancia de pago',
      enable_online_payments: 'Habilitar pagos online',
      save_payment_instance: 'Guardar instancia de pago',
      add_payment_method: 'Agregar método de pago',
      reliquidate: 'Reliquidar',
      disable_rebooker:'Deshabilitar rebooker',
      apply_credits: 'Aplicar créditos',
      generate_record: 'Generar registro',
    },
    saved_queries: {
      remove_label_with_name: 'Eliminar query %{name}',
      new_label: 'Guardar query actual',
      search: 'Buscar',
      remove_all_filters: 'Eliminar todos los filtros',
      go_revision: 'revisiones',
      see_details: 'Ver detalles',
      test_rule: 'Testear',
    },
    boolean: {
      true: 'Sí',
      false: 'No',
    },
    page: {
      list: 'Lista de %{name}',
      edit: '%{name} #%{id}',
      show: '%{name} #%{id}',
      create: 'Crear %{name}',
      dashboard: 'Dashboard',
      not_found: 'No encontrado',
      loading: 'Cargando',
      empty: 'Pagina Vacia',
      invite: 'Crea el primer registro',
    },
    input: {
      file: {
        upload_several:
          'Arrastre algunos archivos para empezar la subida, o presione aquí para seleccionarlos.',
        upload_single: 'Arrastre un archivo para empezar la subida, o presione aquí para seleccionarlo.',
      },
      image: {
        upload_several:
          'Arrastra algunas imágenes para empezar la subida, o presione aquí para seleccionarlas.',
        upload_single: 'Arrastra una imagen aquí para empezar la subida, o presione aquí para seleccionarla.',
      },
      references: {
        all_missing: 'No se encontraron referencias.',
        many_missing: 'Al menos una de las referencias asociadas parece no estar disponible.',
        single_missing: 'La referencia asociada parece no estar disponible.',
      },
      password: {
        toggle_hidden: 'Mostrar / Ocultar',
      },
      placeholder:{
        search: 'Buscar...'
      },
    },
    message: {
      disclaimer_billingform_all_amounts_are_expressed_value_selected_payment_currency_selected: 'Todos los montos están expresados en el valor de la moneda de pago seleccionada.',
      extract_download_available: 'Descarga de extracto disponible.',
      extract_download_error: 'El extracto no existe en la base de datos.',
      select_file: 'Seleccionar archivo...',
      upload_only_xlsx_files: 'Upload only .xlsx files',
      upload_documents_create_reconciliation: 'Cargar documentos para crear conciliación.',
      select_fields_generate_extract_file: 'Seleccionar campos para generar el archivo de extracto.',
      permissions_required: 'Se requieren permisos para acceder.',
      yes: 'Sí',
      no_registry: 'Sin elementos cargados',
      no_search_found: 'No hubo coincidencias',
      yes_search_found: 'Busqueda exitosa',
      no: 'No',
      are_you_sure: '¿Está seguro?',
      about: 'Acerca de',
      not_found: 'Página no encontrada',
      loading: 'La página está cargando, espere un momento por favor',
      invalid_form: 'El formulario no es válido, por favor corregir posibles errores',
      delete_title: 'Borrar %{resource} %{name}',
      delete_content: '¿Está seguro de borrar este elemento?',
      generate_client_title: 'Generar cliente',
      update_items_title: 'Actualizar items',
      import_invoice_title: 'Importar factura',
      import_receipt_title: 'Importar recibo',
      delete_invoice_title: 'Eliminar factura',
      delete_credit_note_title: 'Eliminar Nota de credito',
      confirm_creation_sale_title: 'Confirmar creación negocio en TMA',
      confirm_creation_sale_content: '¿Se ha creado correctamente el negocio en TMA?',
      confirm_add_items_title: 'Confirmar agregación items en TMA',
      confirm_add_items_content: '¿Se han agregado correctamente los items en TMA?',
      init_complete_process: 'Iniciar proceso completo',
      generate_sale_title: 'Generar negocio',
      delete_sale_title: 'Eliminar negocio',
      add_items_title: 'Agregar items',
      generate_invoice_title: 'Generar factura',
      generate_receipt_title: 'Generar recibo',
      generate_receipts_title: 'Generar recibos',
      cancel_receipt_title: 'Anular recibo',
      delete_transaction_title: 'Borrar transacción',
      delete_payment_reservation: 'Borrar pago',
      confirm_action_content: '¿Está seguro de realizar la acción?',
      billingform_reservation_warning: 'Estos valores muestran la información registrada al momento de crear el formulario de cobranzas y no reflejan el estado actual de los mismos.',
      bulk_delete_title: 'Borrar %{name} |||| Borrar %{smart_count} %{name} elementos',
      bulk_delete_content:
        '¿Está seguro de borrar este %{name}? |||| ¿Está seguro de borrar estos %{smart_count} elementos?',
      unsaved_changes: 'Hay cambios sin guardar',
      configuration: 'Configuración de %{name}',
      unmatch_amount_to_pay: 'El importe total ingresado no alcanza para saldar los items seleccionados',
      reservation_item_not_found: 'El item de la reserva no ha sido encontrado',
      has_not_currencies_by_business_unit: 'La unidad de unidad de negocio no tiene monedas disponibles',
      has_not_business_unit_to_get_currencies: 'No hay unidad de negocio disponible para obtener sus monedas',
      credit_in_favor_message:
        'El monto total de pagos sin costos adicionales equivalente a %{type_currency}  $ %{total_amount} es superior al importe total de items seleccionados %{type_currency} $ %{item_total_amount}, ¿desea que la diferencia %{type_currency} $ %{rest_amount} se registre como "pago a cuenta"?',
      validate_amount_to_use: 'El importe a utilizar excede importe total',
      credit_in_favor_item_message:
        'El monto a pagar %{currency} %{total_amount} es superior al importe pendiente del ítem seleccionado  %{currency} %{item_total_amount}, ¿desea que la diferencia %{currency} %{rest_amount} se registre como "pago a cuenta"?',
      all_route: 'Para no discriminar por alguna ruta en particular escribe la palabra "todas".',
      invalid_format: 'El formato es invalido',
      format_route:
        'El formato de la ruta debe ser de esta manera "XXX-XXX", por ejemplo "BUE-MIA", "CBA-MDA"',
      error_formula: 'Lo sentimos, Hubo un problema al resolver la formula !Por favor vuelva a intentar!',
      number_input:
        'La proridad aumenta mientras el número sea mas grande, 1 es la prioridad minima y 100.000 la maxima',
      combine_formula_error: 'No se ha podido combinar la formula con la formula de la regla padre',
      cobine_formula_success: 'Se ha conbinado la formula con la de la regla padre',
      cobine_formula_remove: 'Se ha eliminado la combinacion de la formula con la de la regla padre',
      already_used: '%{name} ya esta en uso',
      desglose_var: 'Esta Variable se mostrara en el desglose',
      global_variable: 'Varible global',
      global_variable_and_show: 'Esta varaible global se mostrara en el desglose',
      sitio_var: 'Esta Variable se mostrara en el sitio',
      desglose_and_sitio_var: 'Esta Variable se mostrara en el sitio y en el desglose',
      acept: 'Aceptar',
      cancel_item_reserva: '¿Está seguro de cancelar esta reserva %{reserva}?',
      cancel_status_item_reserva: '¿Está seguro de cambiar el estado de la reserva %{reserva} a CANCELADO?',
      cancel_train_segment_reserva:
        '¿Está seguro de cancelar esta reserva %{reserva}?, El costo a pagar por la cancelación será de %{currency} %{cost}',
      delete_item_reserva: '¿Está seguro de eliminar el item %{item}?',
      guarantee_item_reserva: '¿Está seguro de garantizar el item %{item}?',
      cancel_item_segment:
        '¿Está seguro de cancelar este tramo %{segment}?, El costo a pagar por la cancelación será de %{currency} %{cost}',
      delete_item_segment: '¿Está seguro de eliminar este tramo %{segment}?',
      emit_item_reserva: '¿Está seguro de emitir esta reserva %{reserva}?',
      emit_status_item_reserva: '¿Está seguro de cambiar el estado de la reserva %{reserva} a EMITIDO?',
      refresh_retrive_item_reserva: '¿Está seguro que desea actualizar la reserva %{reserva}?',
      rule_not_apply: 'La regla de %{rule} no fue aplicada correctamente',
      error_create_item: 'Ha ocurrido un error al crear el producto',
      error_update_item: 'Ha ocurrido un error al editar el producto',
      success_create_item: 'El producto fue creado correctamente',
      success_edit_item: 'El producto fue editado correctamente',
      delete_currency: '¿Está seguro de eliminar esta moneda? Se borrará permanentemente',
      delete_product: '¿Está seguro de eliminar este producto? Se borrará permanentemente',
      delete_email: '¿Está seguro de eliminar este email? Se borrará permanentemente',
      delete_banner: '¿Está seguro de eliminar este banner? Se borrará permanentemente',
      delete_landing: '¿Está seguro de eliminar esta landing? Se borrará permanentemente',
      delete_sector: '¿Está seguro de eliminar este sector? Se borrará permanentemente',
      integrity_error: 'No ha podido eliminar debido a que este registro forma parte de otro registro',
      total_payment_in: 'Total a pagar en ',
      subtotal_in: 'Subtotal en ',
      filter_by_work_unit: 'Filtrar por Unidad de Trabajo',
      filter_by_business_unit: 'Filtrar por Unidad de Negocio',
      filter_by_seller: 'Filtrar por Vendedor',
      export_success: 'Solicitud recibida, se enviará el reporte a %{email} a la brevedad.',
      export_error: 'Error al solicitar los datos',
      import_success: 'Los datos se han importado correctamente',
      import_error: 'Error al importar los datos',
      supplier_error: 'Error al solicitar los proveedores',
      enter_data_manually: 'Introducir datos manualmente',
      retrieve_supplier_data: 'Recuperar datos del proveedor',
      get_available_tickets: 'Obtener tickets disponibles',
      change_password_title: 'Cambiar contraseña',
      invalid_password: 'Contraseña inválida',
      no_have_credits: 'No tienes creditos disponibles',
      reservation_found: 'La reserva %{reservation_number} fue encontrada',
      reservation_not_found: 'La reserva %{reservation_number} NO fue encontrada',
      reservation_payment_generate_success:
        'El pago de la reserva  %{reservation_number} fue registrado exitosamente!',
      reservation_payment_generate_error: 'El pago de la reserva  %{reservation_number} NO fue registrado!',
      negative_amount_error: 'El Importe a aplicar no puede ser negativo',
      item_payment_generate_success: 'Pago registrado con éxito.',
      item_payment_generate_error: 'No se pudo registrar el pago.',
      add_glosa_title: 'Añadir texto',
      add_glosa_content: '¿Desea agregar un texto a la factura?',
      optional: 'Opcional',
      non_refundable: 'Item no reembolsable',
      always_cheapest: '¿Siempre el más barato?',
      transaction_detail_title: 'Detalle de transacción',
      sure_to_clone: '¿Estás seguro de que quieres clonar esta/este %{entity}?',
      rule_error: 'Error en la regla de liquidación',
      clone_reservation: '¿Estás seguro de clonar esta reserva %{reserva}?',
      force_cancel: 'Hubo un error en la cancelación, ¿desea forzar el cambio de estado a CANCELADO?',
      invalid_cuit: 'CUIT mal ingresado',
      valid_characters: 'Ingresa al menos %{num} caracteres para buscar',
      error_to_format_pricing: 'Hubo un error al tomar el pricing del item',
      error_to_delete_formula_global_variables:
        'Error al eliminar %{name}, primero debes quitar la variables de las siguentes reglas',
      transaction_refund_success: 'La transacción fue reembolsada con éxito.',
      transaction_refund_error: 'Hubo un error al reembolsar la transacción',
      capture_payment_success: 'El pago fue capturado con éxito.',
      capture_payment_error: 'Hubo un error al capturar el pago.',
      refund_transaction_title: 'Reembolsar transacción',
      capture_payment_title: 'Capturar pago',
      confirm_separation: '¿Esta seguro separar los/el pasajeros/pasajero?',
      ivalid_amount_passenger:
        'La suma total de importe por pasajero (%{passenger_amount}) excede el monto total del pago (%{payment_type_amount})',
      refresh_void_item_reserva: '¿Está seguro que desea voidear la reserva %{reserva}?',
      not_found_imagen_size: 'No se encontró la imagen con las extensiones proporcionadas.',
      field_to_calculate_liquidation:
        'Para calcular la liquidación, es necesario rellenar los siguientes campos: Fuente, Moneda, Proveedor, Neto proveedor, Destino, Tipo de destino e Inicio de servicio',
      delete_date_rate: '¿Está seguro de eliminar este rango de fecha? Se borrará permanentemente',
      delete_due_date_method:
        '¿Está seguro de eliminar este modelo de vencimiento? Se borrará permanentemente',
      no_data: 'No hay datos',
      has_no_children: 'No tiene hijos',
      no_options_availble: 'No hay opciones disponibles ',
      no_passenger: 'No hay pasajeros',
      no_content_to_display: 'No hay contenido para mostrar',
      email_sent_to: 'Email enviado a:',
      product_value_assignment_text:
        'Ingrese el código json del de Productos en el campo *%{json_product}* para cargar el contenido del campo *JSON*. Seleccione una fuente de datos en *%{detail_table}%* para cargar el contenido de *tableName*. Finalmente seleccione en la tabla *JSON* los valores que desea asociar en *tableName*, haciendo la selección en el valor de *tableName* que desee asignarlo.',
      select_option: 'Seleccione una opcion:',
      rule_formula_explantion:
        'Para mover fórmulas entre páginas, seleccione la fórmula que desea mover. Sin soltar la fórmula, mueva el mouse hasta la página a la que desea moverla. La página cambiará automáticamente y podrá posicionar la fórmula en el lugar deseado.',
      select_at_least: 'Seleccione al menos %{num} caracteres',
      instructive_work_unit_select:
        '*Si deseas seleccionar multiples opciones, solo se pueden seleccionar las unidades de trabajo de un mismo nivel.',
      instructive_paymen_type:
        'Agregar métodos de pago" podra seleccionar el tipo de pago que quiera utilizar.',
      ref_site: 'Nombre de referencia para el sitio',
      approve_fraud: '¿Está seguro de que desea aprobar la revisión de fraude?',
      refuse_fraud: '¿Está seguro de que desea rechazar la revisión de fraude?',
      my_devices_duration_message:
        'Tienes la sesión activa en estos dispositivos o has iniciado sesión en ellos en los últimos 30 días. Es posible que aparezcan varias sesiones del mismo dispositivo.',
      one_session_active: '1 sesión en un',
      your_current_session: 'Tu sesión en curso',
      logout_device: '¿Está seguro de eliminar este dispositivo %{device}?',
      device_disabled_success: 'El dispositivo fue eliminado exitosamente!',
      device_disabled_error: 'Hubo un error al eliminar el dispositivo.',
      generates_multiple_receipt_success: 'El recibo fue generado correctamente.',
      generates_multiple_receipt_error: 'Hubo un error al generar el recibo.',
      no_details_available: 'No hay detalles disponibles',
      error_to_load_details: 'Hubo un error al cargar detalles',
      delete_business_TMA_message: 'Esta acción habilita bajar nuevamente los ítems a TMA',
      delete_business_action_TMA_message: 'Esta acción anula el negocio en TMA y los ítems que contenga',
      import_credit_note_title: 'Importar Nota de credito',
      generate_credit_note_title: 'Generar Nota de credito',
      error_RUT: 'RUT mal ingresado, Debe contener hasta 12 caracteres',
      error_CUIT: 'CUIT mal ingresado',
      number_exist: 'El número ingresado ya existe',
      billing_error: 'Ha ocurrido un error al procesar Facturacion',
      success_payment_and_receipt_error: 'El pago fue registrado pero el recibo falló',
      paymentMethodNotConfigured: 'Este medio de pago aún no ha sido configurado, por favor, contáctese con soporte',
      noFilesUploaded: 'No hay archivos subidos',
      noReservationsSelected: 'Aún no hay reservas seleccionadas',
      noOpenReservationsFound: 'No se encontraron reservas de estado abierto',
      enableFilter: 'Active el filtro para listar las reservas de estado abierto disponibles',
      unavailable: 'No disponible',
      noInformationAvailable: 'No hay información disponible.',
      completed: 'Realizado',
      attention: 'Atención',
      confirmOrEditData: 'A continuación, puede confirmar los datos ingresados previamente o regresar al formulario para realizar modificaciones.',
      paymentRegisteredSuccess: '¡Pago registrado exitosamente!',
      paymentAppliedToReservations: 'El pago ha sido aplicado correctamente a las reservas seleccionadas',
      paymentRegistrationError: 'Error al registrar el pago',
      tryAgain: 'Por favor, inténtalo de nuevo.',
      noResultsAvailable: 'No hay resultados disponibles',
      createRelationsBetweenCurrenciesAndBases: 'Necesita crear las siguientes relaciones entre monedas y bases para poder continuar',
      beforeDeleting: 'Antes de eliminar',
      deleteCurrencyBaseConfirmation: '¿Estás seguro de que deseas eliminar esta configuración de moneda-base?',
      assignedMultipleTimesInRelationship: 'se encuentra asignada más de una vez en la relación',
      incompleteRelationshipBetween: 'Falta completar la relación entre',
      forTheRelationship: 'Para la relación',
      missingFollowingBases: 'faltan las siguientes bases',
      theRelationshipBetween: 'La relación entre',
      noAssignedValue: 'no tiene un valor asignado',
      missingValuesForBases: 'falta asignar los valores a las bases',
      changesAppliedSuccessfully: 'Cambios aplicados exitosamente, vuelva a ejecutar el guardado',
      paymentRegistrationExchangeRateError: 'No se puede continuar con el registro del pago ya que no existe un tipo de cambio para la fecha ',
      contactSupportMessage: 'Por favor, pónganse en contacto con soporte.',
      invalid_json: 'JSON inválido',
      enter_json: 'Ingresa el Json',
      copy_to_clipboard: 'Copiar al portapapeles',
      reservation_to_without_business:
        'La reserva seleccionada no tiene un negocio generado. Por favor, genera un negocio en la reserva seleccionada o elige otra reserva para mover los créditos.',
      reservation_from_without_business:
        'La reserva actual no tiene un negocio generado. Por favor, genera un negocio en la reserva actual para mover los créditos hacia otra reserva.',
      generate_provider_order: 'Generación de Orden de pago Proveedor',
      amount_exceeds_unused:
        'El monto excede el monto total de creditos (%{amount_credit})',
      delete_comment: '¿Está seguro de que desea eliminar este comentario?',
      pending_amount_error: 'Error: Aún queda saldo pendiente por imputar.',
      allocation_amount_error: 'Error: La imputación es mayor al importe abonado.',
      delete_requirement: '¿Está seguro de que desea eliminar este requerimiento?',
      delete_requirement_success: 'Requerimiento eliminado con éxito',
      delete_requirement_error:'No se pudo eliminar el requerimiento',
      download_export_success: 'Archivo exportado éxitosamente.',
      view_refound_amount: 'Ver penalidad del reembolso',
      generate_supplier_payment_order: 'Generar orden de pago proveedor',
      generate_client_payment_order: 'Generar orden de pago cliente',
      pending_amount_error: 'Error: Aún queda saldo pendiente por imputar.',
      allocation_amount_error: 'Error: La imputación es mayor al importe abonado.',
      register_return: '¿Está seguro de que desea registrar la devolución del item?',
      assigned: 'Asignadas',
      watched: 'Observadas',
      created:'Creadas',
      after_sales:'¿Está seguro de que desea realizar la postventa de la reserva %{reserva}?',
      assigned: 'Asignadas',
      watched: 'Observadas',
      created:'Creadas',
      edit_notification_success: 'Notificación editada éxitosamente',
      edit_notification_error: 'Hubo un error al editar la notificación',
      delete_notification_confirm: '¿Está seguro de que desea eliminar la notificación?',
      delete_notification_success: 'Notificación eliminada éxitosamente',
      delete_notification_error: 'No se pudo eliminar la notificación',
      change_status: 'cambió el estado a %{status}',
      change_status_error: 'Hubo un error al cambiar el estado de la reserva',
      added_reservation: 'agregó la reserva %{reservation}',
      removed_reservation: 'quitó la reserva %{reservation}',
      changed_subject: 'modificó el asunto a "%{subject}"',
      changed_description: 'modificó la descripción a "%{description}"',
      assign_item: 'asignó el item "%{item}"',
      changed_type: 'modificó el tipo a "%{type}"',
      file_added: 'añadió el archivo "%{file}"',
      file_removed: 'eliminó el archivo "%{file}"',
      and:'y',
      updated_notification:'actualizó la notificación',
      notification_not_found:'No se encontró la notificación',
      assigned_to:'asignó a %{user}',
      changed_priority:'cambió la prioridad de %{old_priority} a %{new_priority}',
      add_notification:'%{user} añadió la notificación',
      notification_filter_error: 'Ocurrió un error al filtrar las notificaciones',
      unapply_payment: '¿Está seguro de que desea desaplicar el pago?',
      unapply_payment_success: 'Pago desaplicado éxitosamente',
      unapply_payment_error: 'Ocurrió un error al desaplicar el pago',
      edit_notification_success: 'Notificación editada éxitosamente',
      edit_notification_error: 'Hubo un error al editar la notificación',
      return_success:'Monto devuelto correctamente',
      return_error:'Hubo un error al devolver el monto',
      payment_found:'No se puede mover el item porque tiene un pago aplicado',
      payment_found_delete:'No se puede eliminar el item porque tiene un pago aplicado',
      update_status_error: 'No se pudo modificar el estado',
      changed_tracker_id: 'cambió el tracker id a %{new_tracker_id}',
      added_link: 'cambió el link de las reservas %{new_link}',
      credit_generated_success: 'Crédito generado éxitosamente',
      credit_generated_error: 'No se pudo generar el crédito',
      due_tooltip: 'Activa o desactiva esta sección para ver sólo las reservas vencidas en el Detalle por Reserva',
      to_due_tooltip:'Activa o desactiva esta sección para ver sólo las reservas a vencer en el Detalle por Reserva',
      credits_tooltip:'Haz clic aquí para ir al Detalle por Reserva de créditos',
      unapply_confirmation:'¿Desea desaplicar la transacción de importe %{currency} %{amount}?',
      amount_to_pay_error: 'La suma de los montos a pagar no puede ser mayor al total',
      up_to_date:'Estás al día',
      unapply_payment_item:'¿Desea desaplicar el pago aplicado al item %{description}',
      notification_redirect_error:'Notificacion asociada a varias reservas, no es posible ejecutar el acceso directo a las mismas. Sólo será posible cuando el mensaje esta asociado a una única Reserva.',
      amount_to_pay_requiered: 'El monto a pagar es obligatorio',
      open_status:'¿Esta seguro desea cambiar el estado de la reserva %{reserva} a ABIERTA?',
      edit_report_success:'Reporte editado correctamente',
      edit_report_error:'Hubo un error al editar el reporte',
      create_report_success:'Reporte creado correctamente',
      create_report_error:'Hubo un error al crear el reporte',
      confirmation_delete_paymentes_product:'¿Está seguro de que desea eliminar las instancias de pago asociadas al producto %{product}?',
      payment_product_decription:'Configurá las instancias de pago por producto',
      payment_instance_deleted:'Instancia de pago eliminada correctamente',
      payment_instance_delete_error: 'Hubo un error al eliminar la instancia de pago',
      every_day:'Todos los días',
      detailed_by_item:'Detallado por item',
      general_detailed: 'Detallado general',
      preconfigured: 'Preconfigurado',
      on_demand_date:'A demanda - Por fechas',
      on_demand_reserve:'A demanda - Por N° Reserva',
      on_demand:'A demanda',
      daily:'Diaria',
      weekly:'Semanal',
      monthly:'Mensual',
      yesterday:'Ayer',
      last_days:'Ultimos 7 días',
      current_week:'Esta semana',
      last_week:'Semana pasada',
      current_month:'Este mes',
      last_month:'Mes pasado',
      current_quarter:'Este trimestre',
      previous_quarter:'Trimestre anterior',
      current_year:'Este año',
      last_year:'Año pasado',
      year_to_date:'Año actual hasta hoy',
      month_to_date:'Mes actual hasta hoy',
      week_to_date:'Semana actual hasta hoy',
      unique:'Única',
      commercial:'Comercial',
      payment_allocation:'Imputación de pago',
      reserve_control: 'Control de reservas',
      accounting_control: 'Control contable',
      open_status:'¿Esta seguro desea cambiar el estado de la reserva %{reserva} a ABIERTA?',
      edit_report_success:'Reporte editado correctamente',
      edit_report_error:'Hubo un error al editar el reporte',
      create_report_success:'Reporte creado correctamente',
      create_report_error:'Hubo un error al crear el reporte',
      confirmation_delete_paymentes_product:'¿Está seguro de que desea eliminar las instancias de pago asociadas al producto %{product}?',
      payment_product_decription:'Configurá las instancias de pago por producto',
      payment_instance_deleted:'Instancia de pago eliminada correctamente',
      payment_instance_delete_error: 'Hubo un error al eliminar la instancia de pago',
      every_day:'Todos los días',
      confirm_delete_report: '¿Está seguro de que desea eliminar el reporte %{name}?',
      scheduled:'Programado',
      summarized:'Sumarizado',
      uniqueDateValidation: 'Mañana es la primera fecha disponible para el envío de reportes "Preconfigurados". Crea un reporte "A demanda" si precisas recibirlo ahora.',
      onDemandDateAclaration: "El período máximo de análisis para reportes 'A demanda - Por fechas' es de 2 meses.",
      reliquidation_error:'Hubo un error al reliquidar',
      reliquidation_confirm: '¿Está seguro de que desea ejecutar la reliquidación %{liquidation}?',
      delete_items_title:'Eliminar items',
      disable_rebooker_confirmation:'¿Está seguro de que desea deshabilitar el rebooker?',
      collection: 'Cobranza',
      supplier: 'Proveedor',
      sales: 'Ventas',
      account_state:'Estado de cuenta',
      smartbook: 'Smartbook',
      metasearch: 'Metasearch',
      reservation_B2C: 'Reservas',
      client: 'Cliente',
      delete_chat_bot: '¿Seguro que deseas borrar toda la conversación? Esta acción es irreversible.',
      confirmation_apply_credits: '¿Esta seguro que desea aplicar todos los creditos de la reserva sobre sus items?',
      confirm_delete:'Sí, borrar',
      update_confirmation:'¿Está seguro de que desea actualizar la información?',
      init_process_confirmation:'¿Está seguro de que desea iniciar el proceso?',
      client_tooltip:'Selecciona del listado el Cliente con el cual desees loguearte',
      client_change_confirmation:'¿Está seguro de que desea cambiar de cliente?',
      delete_payments_message:'¿Está seguro de que desea eliminar los pagos?',
      commercial_detail: 'Cobranzas Detalladas',
      billing_mexico: 'Facturación México',
      hepstar: 'Hepstar',
    },
    navigation: {
      no_results: 'No se encontraron resultados',
      no_results_filters: 'No se encontraron resultados. Pruebe modificar los filtros.',
      no_more_results:
        'La página número %{page} se encuentra fuera de los limites. Pruebe con la página anterior.',
      page_out_of_boundaries: 'La página número %{page} se encuentra fuera de los límites',
      page_out_from_end: 'No se puede navegar después de la última página',
      page_out_from_begin: 'No se puede navegar antes de la página 1',
      page_range_info: '%{offsetBegin}-%{offsetEnd} de %{total}',
      page_range_info_billingform: 'Página %{page} de %{totalPages}',
      next: 'Siguiente',
      prev: 'Anterior',
      page_rows_per_page: 'Filas por página',
      skip_nav: 'Saltar',
      of: 'De',
    },
    auth: {
      username: 'Usuario',
      user_menu: 'Usuario',
      password: 'Contraseña',
      login: 'Loguearse',
      sign_in_error: 'Error de autenticación, por favor reintentar',
      sign_in: 'Iniciar sesión',
      logout: 'Cerrar sesión',
      forbidden: 'Tu sesion se vencio, por favor vuelve a iniciar sesion',
      auth_check_error: 'Necesitas estar logeado para acceder a esta vista',
      recover_password: 'Recuperar contraseña',
      recover_password_success: 'Se te ha enviado un mail para recuperar la contraseña',
      badrequest: 'Error en la solicitud',
      unauthorized: 'Error de autorización',
      unknown: 'Error de servidor',
      device_not_found:
        'Usted ha ingresado desde un dispositivo nuevo, por favor revise su correo electronico e ingrese el codigo',
      sign_in_to_different_account: 'Iniciar sesion en una cuenta diferente',
      device_code_invalid: 'El código no es válido. Por favor, ingreselo nuevamente',
      device_code: 'Código de verificación',
      check_your_inbox: 'Comprueba tu bandeja de entrada',
      enter_device_code:
        'Introduce el código de 6 dígitos que hemos enviado a tu correo electronico para completar el inicio de sesión.',
      user_disabled: 'Has superado el número de intentos, deberas reestablecer la contraseña para continuar',
      device_code_expired:
        'El código ha expirado. Se enviara uno nuevo, por favor, revise su correo electrónico.',
      device_with_expired_session:
        'La sesion ha expirado, por favor revise su correo electronico e ingrese el codigo',
      reset_password:
        'Has superado el número de intentos, por seguridad te hemos cambiado la contraseña, la podras visualisar en tu correo electronico',
    },
    status: {
      CANCELLED: 'CANCELADO',
      CANCELED: 'CANCELADO',
      CANCEL_PROVIDER: 'CANCELADO POR PROVEEDOR',
      PENDING: 'PENDIENTE DE EMISIÓN',
      PENDING_BILLING: 'PENDIENTE',
      CONFIRMED: 'CONFIRMADO',
      INVOICED: 'EMITIDO',
      REFUNDED: 'REEMBOLSADO',
      PARTIAL_REFUND: 'PARCIALMENTE REEMBOLSADO',
      OPEN: 'ABIERTA',
      CLOSED: 'CERRADA',
      EXPIRED: 'EXPIRADA',
      EXPIRED_MALE: 'EXPIRADO',
      REFUND_IN_PROGRESS: 'REEMBOLSO EN PROGRESO',
      INVOICE_IN_PROGRESS: 'EMISIÓN EN PROGRESO',
      CANCELLATION_IN_PROGRESS: 'CANCELACIÓN EN PROGRESO',
      VOID_IN_PROGRESS: 'VOID EN PROGRESO',
      PROCESSING: 'EMISIÓN EN PROCESO',
      PAID: 'PAGADO',
      UNPAID: 'PENDIENTE DE PAGO',
      PARTIALLY_PAID: 'PARCIALMENTE PAGO',
      NOT_REQUIRED: 'NO REQUERIDO',
      GUARANTEED: 'GARANTIZADO',
      REJECTED: 'RECHAZADA',
      REJECTED_MALE: 'RECHAZADO',
      PENDING_RESERVATION: 'PENDIENTE DE RESERVA',
      VOID: 'VOID',
      REINVOICED: 'REEMITIDO',
      DELETED: 'ELIMINADO',
      CREATED: 'CREADO',
      null: '-',
      undefined: 'INDEFINIDO',
      ISSUED: 'EMITIDA',
      PREBOOKED: 'PREBOOKED',
      BILLED: 'FACTURADO',
      'NOT REQUIRED': 'NO REQUERIDO',
      'IN RSV': 'EN RESERVA',
      DEFEATED: 'VENCIDO',
      DUE:'A VENCER',
      ERROR: 'ERROR',
      TO_BILLING: 'A FACTURAR',
      APPROVED: 'APROBADO',
      MANUALLY_APPROVED: 'MANUALMENTE APROBADO',
      MANUALLY_DISAPPROVED: 'MANUALMENTE DESAPROBADO',
      FRAUD_ANALYSIS: 'ANALISIS DE FRAUDE',
      DUE_TODAY: 'VENCE HOY',
      status_entered: 'Ingresado',
      status_review: 'En revisión',
      status_rejected: 'Rechazado',
      status_aproved: 'Aprobado',
      status_aproved_partially: 'Aprobado parcial',
      ON_SITE: 'EN SITIO',
      PENDING_OPERATION: 'OPERACIONES',
      INIT_CHECKOUT: 'SOLICITUD CREADA',
      CROSSELL_SELECTED: 'SOLICITUD CROSSELL',
      FLIGHT_BOOKING_COMPLETED: 'AEREO CREADO',
      FRAUD_REVITION: 'FRAUDE EN REVISION',
      PAYMENT_IN_PROCESS: 'PAGO EN PROCESO',
      SESSION_EXPIRED: 'SESION EXPIRADA',
      CASH_PAYMENT_ABANDONED: 'ABANDONO PAGO CASH',
      BOOKING_REJECTED: 'BOOKING FALLIDO',
      PAYMENT_REJECTED: 'PAGO FALLIDO',
      FRAUD: 'FRAUDE',
      PAID_WITHOUR_FEE: 'PAGADO SIN FEE',
      CASH_PAYMENT: 'PAGO CASH',
      NOT_AVAILABILITY: 'ERROR DE DISPONIBILIDAD',
      PREBOOKING_FAILED: 'PREBOOKING FALLIDO',
      RESERVED: 'RESERVADO',
      DUPLICATED: 'DUPLICADO',
      IN_PROCESS: 'EN PROCESO',
      FAILED_INVOICED: 'EMISION FALLIDA',
      FINALIZED: 'FINALIZADA',
      FINISHED: 'FINALIZADA',
      AFTER_SALES: 'POSTVENTA',
      AFTER_SALES_HIDDEN:'POSTVENTA',
      IN_REVIEW:'EN REVISIÓN',
      CREDIT_GENERATED:'CRÉDITO GENERADO',
      CREDIT_NOT_GENERATED:'CRÉDITO NO GENERADO',
      UNAPPLIED:'DESAPLICADO',
      CONFIRMED_UNAPPLIED:'CONFIRMADO-',
    },
    title: {
      create_user: 'Crear un usuario',
      update_user: 'Editar un usuario',
      create_entity: 'Crear una entidad',
      update_entity: 'Editar una entidad',
      create_tag: 'Crear una Etiqueta',
      update_tag: 'Editar una Etiqueta',
      create_role: 'Crear un rol',
      update_role: 'Editar un rol',
      create_processApplication: 'Crear un proceso por aplicación',
      update_processApplication: 'Editar un proceso por aplicación',
      create_process: 'Crear un proceso por módulo',
      update_process: 'Editar un proceso por módulo',
      create_permission: 'Crear un permiso',
      update_permission: 'Editar un permiso',
      create_module: 'Crear un módulo',
      update_module: 'Editar un módulo',
      create_client: 'Crear un cliente',
      update_client: 'Editar cliente',
      create_application: 'Crear una aplicación',
      update_application: 'Editar una aplicación',
      create_businessType: 'Crear un tipo de negocio',
      update_businessType: 'Editar un tipo de negocio',
      create_businessUnit: 'Crear una unidad de negocio',
      update_businessUnit: 'Editar una unidad de negocio',
      create_country: 'Crear un país',
      update_country: 'Editar un país',
      create_currency: 'Crear una moneda',
      create_type_responsible: 'Crear tipo responsable',
      update_type_responsible: 'Editar tipo responsable',
      update_currency: 'Editar una moneda',
      create_documentType: 'Crear un tipo de documento',
      update_documentType: 'Editar un tipo de documento',
      create_product: 'Crear un producto',
      update_product: 'Editar un producto',
      create_workUnit: 'Crear una unidad de trabajo',
      update_workUnit: 'Editar una unidad de trabajo',
      create_bank: 'Crear Cuenta Bancaria',
      update_bank: 'Actualizar Cuenta Bancaria',
      create_businessRule: 'Crear una regla de negocio',
      list_item_to_pay: 'Lista de items a pagar',
      item_selected: 'Item seleccionados',
      update_payment_type: 'Editar Tipo de pago',
      create_payment_type: 'Crear un Tipo de pago',
      credit_in_favor: 'Crédito a favor',
      general_information: 'Información General',
      update_sale: 'Editar venta',
      update_supplier: 'Editar proveedor',
      update_reservation: 'Editar reserva',
      update_source: 'Editar fuente',
      general: 'General',
      filters: 'Filtros',
      products: 'Productos',
      add_product: 'Agregar producto',
      client: 'Cliente',
      passenger: 'Pasajeros',
      add_passenger: 'Agregar pasajero',
      update_passenger: 'Editar pasajero',
      aerial: 'Aereo',
      reserve_information: 'Información de la reserva',
      contanct: 'Contacto',
      observations: 'Observaciones',
      aerial_information: 'Información del vuelo',
      segments: 'Tramos',
      segment: 'Tramo',
      add_segment: 'Agregar otro tramo',
      delete_segment: 'Eliminar tramo',
      going: 'IDA',
      return: 'VUELTA',
      departure: 'Salida',
      arrival: 'Llegada',
      scale: 'Escala',
      duration: 'Duración',
      luggage: 'Equipaje',
      wait_in: 'Espera en el',
      hotel: 'Hotel',
      car: 'Auto',
      air: 'Aereo',
      other: 'Otros',
      train: 'Tren',
      flight: 'Vuelo',
      others: 'Otros',
      other_product: 'Producto (Otros)',
      train_segment: 'Trenes Ticket',
      train_passes: 'Trenes passes',
      billing: 'Facturación',
      hotel_information: 'Información del hotel',
      liquidation: 'Liquidación',
      contact: 'Contacto',
      transfer_information: 'Información del traslado',
      service_information: 'Información del servicio',
      date: 'Fechas',
      direct: 'Directo',
      provider_info: 'Datos del proveedor',
      tags: 'Etiquetas',
      rooms: 'Habitaciones',
      people_by_room: 'persona (s) x1 Habitación.',
      cancellation_cost: 'Gastos de cancelación',
      cancellation_cost_provider: 'Gastos de cancelación proveedor',
      cancellation_cost_client: 'Gastos de cancelación cliente',
      car_information: 'Información del auto',
      trip_car_information: 'Información del viaje',
      train_information: 'Información de trenes',
      customer_file: 'Ficha de cliente',
      total_duration: 'Duracion Total',
      formula: 'Fórmula',
      edit_businessRule: 'Editar Regla',
      solve_formula: 'Formula Resuelta',
      pay_condition: 'Condiciones de pago',
      credits: 'Creditos',
      credit_against: 'saldo a pagar',
      pending_items: 'Items pendientes',
      items_to_bill: 'Items a facturar',
      generated_invoices: 'Facturas generadas',
      actions: 'Acciones',
      payment: 'Cobranza',
      transactions: 'Transacciones',
      pricing: 'Desglose de precio',
      liquidation_retail: 'Liquidación minorista',
      liquidation_supplier: 'Liquidación proveedor',
      liquidation_wholesaler: 'Liquidación mayorista',
      transfer: 'Traslado',
      create_cash: 'Crear caja',
      update_cash: 'Editar caja',
      contact_emergency: 'Contacto de emergencia',
      assistance_information: 'Información de asistencias',
      assistance: 'Asistencias',
      re_assign: 'Reasignar %{entity}',
      update_contact: 'Actualizar contacto',
      update_liquidation: 'Actualizar Liquidación',
      update_card: 'Actualizar tarjeta',
      create_card: 'Crear tarjeta',
      update_pricing: 'Editar valores de origen',
      update_productType: 'Editar tipo de producto',
      create_productType: 'Crear tipo de producto',
      update_variable: 'Editar Variable',
      condition: 'Condiciones',
      tickets: 'Tickets',
      exchange_type: 'Tipo de cambio',
      exchange_types: 'Tipos de cambio',
      recalculate_liquidation_rule: '¿Cuál de las siguientes liquidaciones desea recalcular?',
      empty: 'No hay %{some}',
      update_numbering: 'Editar numeración',
      create_numbering: 'Crear numeración',
      create_source: 'Crear fuente',
      last_sales: 'Últimas Ventas',
      air_tickets: 'Tickets Aéreos %{name}',
      select_client_and_app: 'Seleccione el cliente y la aplicación:',
      sales_with_pending_payment: 'Ventas con pago pendiente',
      notification: 'Notificaciones',
      update_payment_method: 'Editar método de pago',
      create_payment_method: 'Crear método de pago',
      sales_with_paid_payment: 'Ventas con pago abonado',
      sales_with_guaranteed_payment: 'Ventas con pago garantizado',
      reservations_to_pay: 'Reservas para pagar',
      see_items: 'Ver items',
      item_balances: 'Saldos de items',
      reservation_credit: 'Créditos de la reserva',
      send_email: 'Enviar email',
      regenerate_notification: 'Generar nueva notificación y enviar email',
      files: 'Archivos',
      file: 'Archivo',
      files_uploaded: 'Archivos cargados',
      file_name: 'Nombre de archivo',
      create_bannerType: 'Crear tipo de banner',
      update_bannerType: 'Editar tipo de banner',
      create_banner: 'Crear banner',
      update_banner: 'Editar banner',
      create_ext_train_marketing_carrier: 'Crear marketing carrier',
      update_ext_train_marketing_carrier: 'Editar marketing carrier',
      sectors: 'Sectores',
      create_landing: 'Crear landing',
      update_landing: 'Editar landing',
      preview_landing: 'Previsualización landing',
      compensation_credit: 'Compensación de Crédito',
      update_transaction: 'Editar transacción',
      payment_register: 'Registración de Pago',
      addButton: 'Añadir botón',
      update_eticket: 'Editar E-ticket',
      update_date: 'Modificar fecha',
      create_due_date_method: 'Crear modelo de vencimiento',
      update_due_date_method: 'Actualizar modelo de vencimiento',
      create_due_date_range: 'Crear rango de fecha de vencimiento',
      update_due_date_range: 'Actualizar rango de fecha de vencimiento',
      update_pricing_passenger: 'Actualizar valores de origin del pasajero %{passenger}',
      update_exchange_type: 'Editar tipo de cambio',
      product_value_assignment: 'Asignación de valores de Producto',
      update_financial_entity: 'Actualizar Entidad Financiera',
      create_custom_var: 'Crear variable personalizada',
      select_exist_label: 'Seleccionar un Etiqueta existente',
      select_work_unit: 'Selecciona una unidad de trabajo',
      create_company: 'Crear compañía',
      update_company: 'Actualizar compañía',
      create_financial_entity: 'Crear Entidad financiera',
      update_operation_type: 'Actualizar Tipo de operacion',
      create_operation_type: 'Crear Tipo de operacion',
      update_due_date: 'Actualizar fecha de pago de vencimiento',
      my_devices: 'Mis dispositivos',
      credits_applied: 'Creditos aplicados',
      credit_applied_detail: 'Destino de créditos',
      payment_info: 'Información sobre el pago',
      paymentRecord: 'Registro de pago',
      reservationsToPaySelection: 'Selección de reservas a pagar',
      reservationSelection: 'Selección de reservas',
      selectedReservations: 'Reservas seleccionadas',
      selectReservations: 'Seleccionar reservas',
      reservationItems: 'Items de la reserva',
      requestConfirmation: 'Confirmación de solicitud',
      totals: 'Totales',
      applicant: 'Solicitante',
      paymentDetails: 'Datos del pago',
      exchangeRateHistory: 'Histórico de tipos de cambios',
      labelReceiptAndImputation: 'Recibo e imputación',
      history: 'Historial',
      trip_info: 'Información del viaje',
      client_data: 'Datos del Cliente',
      customer_data: 'Datos del Cliente',
      fraud_info: 'Información de Fraude',
      create_commerce_number: 'Crear Número de comercio',
      update_commerce_number: 'Actualizar Número de comercio',
      create_gateway: 'Crear Pasarela de pago',
      update_gateway: 'Actualizar Pasarela de pago',
      move_credit_reservation: 'Mover creditos',
      payment_order_requirement: 'Requerimiento de orden de pago',
      create_installment: 'Crear financiación',
      update_installment: 'Editar financiación',
      import_installment: 'Indica la planilla de financiación que deseas importar',
      operations_required_action: 'Mesa operativa - Acción requerida',
      emited_without_fee: 'Emitido sin fee',
      failed_emit: 'Emisión fallida',
      pending_payment_cash: 'Pendientes de pago - Cash',
      pending_billing: 'Pendiente de facturación',
      transactions_resume: '(Fecha del día de hoy) Resumen de transacciones',
      in_site: 'En sitio',
      reserved: 'Reservados',
      cancelled: 'Cancelados',
      error: 'Error',
      issued: 'Emitidos',
      share_by_status: 'Share por estado',
      share_by_cancelation_type: 'Share por tipo de cancelación',
      cancelled_by_fraud: 'Cancelados por fraude',
      cancelled_by_failed_payment: 'Cancelados por pago fallido',
      cancelled_by_failed_booking: 'Cancelados por booking fallido',
      cancelled_by_payment_cash: 'Cancelados pago cash',
      cancelled_by_expired_session: 'Cancelados por sesión expirada',
      general_conditions: 'Condiciones generales',
      fee_conditions: 'Condiciones de la tarifa',
      user_agent: 'Agente',
      last_login: 'Último inicio de sesión',
      suppliers_actions: 'Acciones proveedores',
      reserve_requirement: 'Requerimientos de la reserva',
      clients_actions: 'Acciones clientes',
      price_history: 'Histórico de precios',
      origin_values: 'Valores de origen',
      returns: 'Devoluciones',
      code_edit: 'Editar códigos',
      update_status:'Modificar estado',
      balances: 'Saldos',
      how_much_to_pay: '¿Cuánto debo pagar hoy?',
      weekly_due_dates: 'Vencimientos semanales',
      debt_per_period:'Deuda por período',
      detail_per_reservation: 'Detalle por reserva',
      last_payments: 'Últimos pagos',
      whith_balances: 'Con saldos',
      with_credits: 'Con créditos',
      balance_to_pay:'Saldo a pagar',
      edit_report: 'Editar reporte',
      scheduled_reports: 'Reportes programados',
      generated_reports: 'Reportes generados',
      credits_data: 'Datos del crédito',
      noDataAvailable: 'No hay datos',
      billing_number: 'Ingrese el número del item para facturación:',
      balance_transfer_received: 'Pases de saldo recibidos',
      balance_transfer_sent: 'Pases de saldo enviados',
      confirm_action:'Confirmar acción',
      generate_business_items:'Generar Negocio + Items',
      clients:'CLIENTES',
      suppliers: 'Proveedores',
      edit_config: 'Editar configuración',
    },
    notification: {
      noRoleApplication: 'No se han encontrado roles para la aplicación seleccionada',
      noPermissionApplication: 'No se han encontrado permisos para la aplicación seleccionada',
      noApplicationClient: 'No se han encontrado aplicaciones para el cliente seleccionado',
      clientsNotFound: 'No se han encontrado clientes',
      updated: 'Elemento actualizado |||| %{smart_count} elementos actualizados',
      created: 'Elemento creado',
      deleted: 'Elemento borrado |||| %{smart_count} elementos borrados',
      bad_item: 'Elemento incorrecto',
      item_doesnt_exist: 'El elemento no existe',
      http_error: 'Error de comunicación con el servidor',
      canceled: 'Acción cancelada',
      error_updated: 'Lo sentimos, no pudimos actualizar el Elemento  %{smart_count}',
      data_provider_error: 'Lo sentimos, hubo un problema con el proveedor de datos',
      no_static_json: 'No se ha encontrado nigún JSON predeterminado',
      created_success_masculine: 'El %{element} ha sido creado correctamente',
      created_success_femenine: 'La %{element} ha sido creada correctamente',
      created_error_masculine: 'El %{element} no ha sido creado',
      created_error_femenine: 'La %{element} no ha sido creada',
      updated_success_masculine: 'El %{element} ha sido actualizado correctamente',
      updated_success_femenine: 'La %{element} ha sido actualizada correctamente',
      updated_error_masculine: 'El %{element} no ha sido actualizado',
      updated_error_femenine: 'La %{element} no ha sido actualizada',
      deleted_success_masculine: 'El %{element} ha sido borrado correctamente',
      deleted_success_femenine: 'La %{element} ha sido borrada correctamente',
      deleted_error_masculine: 'El %{element} no ha sido borrado',
      deleted_error_femenine: 'La %{element} no ha sido borrada',
      canceled_item_reserve_success: 'La Reserva %{reserve} fue cancelada',
      cancellation_in_progress: 'Cancelación de %{reserve} solicitada',
      canceled_item_reserve_error: 'La Reserva %{reserve} NO fue cancelada',
      delete_item_error: 'El item %{item} NO fue eliminado',
      delete_item_success: 'El item %{item} fue eliminado',
      emit_status_item_success: 'El item %{item} fue emitido',
      emit_status_item_error: 'El item %{item} NO fue emitido',
      cancel_status_item_success: 'El item %{item} fue cancelado',
      cancel_status_item_error: 'El item %{item} NO fue cancelado',
      guarantee_item_success: 'El item %{item} fue garantizado',
      guarantee_item_error: 'El item %{item} NO fue garantizado',
      move_item_success: 'El item %{item} fue movido',
      move_item_error: 'El item %{item} NO fue movido',
      emit_item_reserve_success: 'La emisión de la reserva %{reserve} fue solicitada',
      emit_item_reserve_error: 'La emisión de la reserva %{reserve} NO fue solicitada',
      emit_item_fail_reserve_error: 'Hubo un error, La reserva %{reserve} NO fue emitida',
      retrive_item_reserve_success: 'La reserva %{reserve} fue actualizada',
      retrive_item_reserve_error: 'Hubo un error, La reserva %{reserve} NO fue actualizada',
      issuance_segment_item_reserve_success: 'El segmento %{segment} fue reembolsado',
      issuance_segment_item_reserve_error: 'El segmento %{segment} NO fue reembolsado',
      delete_segment_item_reserve_success: 'El segmento %{segment} fue eliminado',
      delete_segment_item_reserve_error: 'El segmento %{segment} NO fue eliminado',
      updated_success_passenger: 'El pasajero %{passenger} ha sido actualizado correctamente',
      updated_success_titular: 'El pasajero %{passenger} ahora es titular',
      updated_error_titular: 'El pasajero %{passenger} no se pudo actualizar',
      updated_success_business_unit: 'El cliente ha sido actualizado a %{client}',
      updated_error_business_unit: 'No se ha podido actualizar el cliente',
      add_success_passenger: 'El pasajero %{passenger} fue agregado correctamente',
      add_error_passenger: 'No se ha podido agregar el pasajero',
      success_full_process: 'Se ha completado el proceso completo correctamente',
      error_full_process: 'No se ha completado el proceso completo',
      created_success_sale_reservation: 'Negocio generado correctamente',
      created_error_sale_reservation: 'No se ha podido generar el negocio',
      deleted_success_sale_reservation: 'Negocio eliminado correctamente',
      deleted_error_sale_reservation: 'No se ha podido eliminar el negocio',
      deleted_success_invoice_reservation: 'Factura eliminada correctamente',
      deleted_success_credit_note_reservation: 'Nota de credito eliminada correctamente',
      deleted_error_invoice_reservation: 'No se ha podido eliminar la factura',
      deleted_error_credit_note_reservation: 'No se ha podido eliminar la nota de credito',
      created_success_add_items_reservation: 'Items agregados correctamente',
      created_error_add_items_reservation: 'No se han podido agregar las items',
      updated_error_items_success: 'Los items se han actualizado correctamente',
      updated_error_items_error: 'Los items NO se han actualizado',
      updated_success_contact: 'El Contacto %{contact} ha sido actualizado',
      add_tag_success: 'La etiqueta fue agregado',
      add_tag_error: 'La etiqueta NO fue agregado',
      remove_tag_error: 'Hubo un problema al borrar la etiqueta',
      updated_error_contact: 'El Contacto no se pudo actualizar',
      updated_success_pricing: 'El precio ha sido actualizado',
      updated_error_pricing: 'El precio no se pudo actualizar',
      updated_success_seller: 'El Vendedor ha sido actualizado',
      updated_error_seller: 'No se ha podido actualizar el Vendedor',
      updated_success_liquidation: 'la liquidación ha sido actualizado',
      updated_error_liquidation: 'El liquidación no se pudo actualizar',
      liquidation_rule_invalid: 'Las variables esta ocultas o la regla fue mal cargada',
      check_extra_cost: 'Por favor asegurese de que todos los costos extras fueron calculados',
      error_retrieve: 'Ha habido un error al recuperar los datos del proveedor',
      error_loading_products: 'Ha habido un error al cargar los productos',
      change_password_success: 'La contraseña ha sido cambiada correctamente',
      change_password_error: 'La contraseña NO ha sido cambiada',
      forward_email_to_success: 'El email fue enviado a %{email_to}',
      forward_email_to_error: 'Sucedió un error al enviar el Email, por favor intenta más tarde',
      regenerate_notification_to_success: 'La notificación ha sido generada correctamente',
      regenerate_notification_to_error:
        'Sucedió un error al generar notificación, por favor intenta más tarde',
      create_error_banner_by_work_unit: 'No se han podido agregar los banners a la unidad de trabajo',
      create_error_banner_by_business_unit: 'No se han podido agregar los banners a la unidad de negocio',
      update_error_banner_by_work_unit: 'No se han podido actualizar los banners de la unidad de trabajo',
      update_error_banner_by_business_unit: 'No se han podido actualizar los banners de la unidad de negocio',
      upload_image_error: 'Se ha producido un error al subir la imagen',
      clone_item_success: 'El item %{item} fue clonado',
      clone_item_error: 'El item %{item} NO fue clonado',
      aftersales_item_success: 'La postventa para el item %{item} fue creada',
      aftersales_item_error: 'La postventa para el item %{item} NO fue creada',
      error_update_view: 'Hubo un error al intetar actualizar la vista.',
      already_update_view: 'La vista fue actualizada recientemente, por favor vuelve a intentar mas tarde.',
      success_update_view: 'La vista fue actualizada.',
      applied_credit_success: 'Credito aplicado exitosamente!',
      applied_credit_error: 'Hubo un error al aplicar el credito',
      update_transaction_success: 'La transacción fue actualizada exitosamente!',
      update_transaction_error: 'Hubo un error al actualizar la transacción',
      currency_not_found_in_business_unit:
        'La moneda %{currency} no existe en el listado de monedas de la unidad de negocio',
      pnr_used: 'El PNR ya fue importado o no existe',
      splited_item_reserve_error: 'Hubo un error al intentar separar los/el pasejeros/pasajero',
      splited_item_reserve_success: 'Separacion exitosa!',
      void_item_reserve_success: 'La reserva %{reserve} fue voideada exitosamente!',
      void_item_reserve_error: 'Hubo un error al intentar voidear la reserva %{reserve}',
      due_date_success: 'La fecha fue actualizada exitosamente!',
      due_date_error: 'Hubo un error al intentar actualizar La fecha',
      update_error_date_range: 'Hubo un error al intentar actualizar el rango de fecha',
      create_error_date_range: 'Hubo un error al intentar crear el rango de fecha',
      delete_error_date_range: 'Hubo un error al intentar borrar el rango de fecha',
      delete_success_date_range: 'El rango de fecha fue borrado exitosamente!',
      delete_error_due_date_method: 'Hubo un error al intentar borrar el metodo de fecha de vencimiento',
      delete_success_due_date_method: 'El metodo de fecha de vencimiento fue borrado exitosamente!',
      approve_fraud_item_reserve_success: 'El análisis de fraude fue aprobado correctamente',
      approve_fraud_item_reserve_error: 'No se ha podido aprobar el análisis de fraude',
      refuse_fraud_item_reserve_success: 'El análisis de fraude fue rechazado correctamente',
      refuse_fraud_item_reserve_error: 'No se ha podido rechazar el análisis de fraude',
      relationshipDeletedSuccess: 'Relación eliminada exitosamente',
      errorDeletingRelationship: 'Error al eliminar la relación',
      transfer_credit_success: 'Los creditos fueron transferidos exitosamente!',
      transfer_credit_error: 'Hubo un error al transferir los creditos',
      generate_order_success: 'La orden de pago fue generada correctamente!',
      generate_order_error: 'Hubo al generar la orden de pago',
      no_gateway_options: 'No existe opción de pasarela habilitada',
      generate_order_error: 'Hubo un error al generar la orden de pago',
      no_gateway_options: 'No existe opción de pasarela habilitada',
      unapply_payment_success: 'Pago desaplicado éxitosamente',
      unapply_payment_error: 'El pago no se pudo desaplicar.',
      register_return_success: 'El item %{item} fue devuelto',
      register_return_error: 'El item %{item} no fue devuelto',
      edit_codes_error: 'Los códigos no se pudieron actualizar',
      report_deleted_success: 'El reporte fue eliminado correctamente',
      report_deleted_error: 'Hubo un error al eliminar el reporte',
      credit_updated_success:'Crédito actualizado correctamente',
      credit_updated_error:'Crédito no actualizado',
      delete_error_items_success: 'Los items se han eliminado correctamente',
      delete_error_items_error: 'Los items NO se han eiminado',
      disable_rebooker_success: 'Rebooker deshabilitado correctamente',
      disable_rebooker_error: 'Hubo un error al deshabilitar el rebooker',
      send_question_error: 'Hubo un error el enviar la pregunta',
      apply_credits_success: 'Los créditos fueron aplicados éxitosamente',
      apply_credits_error: 'Hubo un error al aplicar los créditos',
      edit_business_number_success:'Número de negocio editado correctamente',
      edit_business_number_error:'Hubo un error al editar el número de negocio',
      updated_notifications_success:'Las notificaciones se actualizaron correctamente',
      updated_notifications_error:'Hubo un error al actualizar las notificaciones',
      max_chars_prompt:'Tu pregunta no puede exceder los 1000 caracteres de longitud',
    },
    validation: {
      required: 'Requerido',
      minLength: 'Debe tener al menos %{min} caracteres',
      maxLength: 'Debe tener %{max} caracteres o menos',
      minValue: 'Valor debe ser mayor a %{min}',
      maxValue: 'Valor debe ser menor a %{max}',
      number: 'Debe ser un número',
      email: 'Debe ingresar un correo electrónico válido',
      oneOf: 'Debe ser uno de los siguientes valores: %{options}',
      regex: 'Debe seguir un formato específico (regexp): %{pattern}',
      date_invalid: 'Por favor, ingresar una fecha válida',
      date_min: 'Por favor, ingresar una fecha mayor',
      date_max: 'Por favor, ingresar una fecha menor',
      noOptionsText: 'No hay opciones',
      minCharacters: 'Introduce al menos dos caracteres para buscar',
      time_invalid: 'Por favor, ingresa una hora válida',
      maxCharacters: 'Excediste el maximo de caracteres, deben ser menos de %{characters}',
      fieldIsRequired: 'Este campo es obligatorio',
      errorCreatingBases: 'Parece que ocurrió un error al crear las bases. Por favor, revisa que todos los campos estén completos.',
      errorCreatingBasesValues: 'Parece que ocurrió un error al crear las bases. Los valores de las relaciones deben ser mayores a 0.',
      errorCreatingBasesUniqueCombinations: 'Parece que ocurrió un error al crear las bases. Las combinaciones de moneda de origen, moneda de destino y base deben ser únicas.',
      missingFields: 'Faltan completar campos obligatorios',
      noSpaces:'No se permiten espacios en blanco',
    },
    tooltiptext: {
      rule_type_first: 'Debe seleccionar el tipo de regla primero',
    },
    modules: {
      authentication: 'Autenticación',
      administration: 'Administración',
      marketing: 'Gestión de Contenidos',
      sales: 'Ventas',
      payment: 'Pagos',
      setup: 'Configuración',
      rules: 'Reglas',
    },
    single_entity: {
      application: 'aplicación',
      client: 'cliente',
      module: 'módulo',
      permission: 'permiso',
      process: 'proceso por módulo',
      processApplication: 'proceso por aplicación',
      role: 'rol',
      user: 'usuario',
      'business-type': 'tipo de negocio',
      'business-unit': 'unidad de negocio',
      country: 'país',
      currency: 'moneda',
      'document-type': 'tipo de documento',
      'product-type': 'tipo de producto',
      product: 'producto',
      'work-unit': 'unidad de trabajo',
      'business-rule': 'regla de negocio',
      entity: 'entidad',
      'payment-entity': 'cobranza',
      installment: 'financiación',
      card: 'tarjeta',
      source: 'fuente',
      bank: 'banco',
      expenses: 'gasto',
      'operation-type': 'tipo de operación',
      cash: 'caja',
      company: 'compañía',
      'financial-entity': 'entidad financiera',
      'type-responsible': 'tipo responsable',
      'payment-type': 'tipo de pago',
      'payment-method': 'método de pago',
      type_responsible: 'tipo de responsable',
      reservation: 'reserva',
      supplier: 'proveedor',
      tag: 'etiqueta',
      'banner-type': 'tipo de banner',
      banner: 'banner',
      'ext-train-marketing-carrier': 'marketing carrier',
      landing: 'landing',
      'formula-global-variables': 'Variable global de formula',
      'due-date-method': 'Métodos de fecha de vencimiento',
      'date-range': 'Calendario de Vencimiento',
      'due-date-range': 'Vencimiento de Pago',
      gateway: 'Pasarela de pago',
      'commerce-number': 'Número de comercio',
      operation: 'operación',
      'operation-bff': 'operación BFF',
      'route-config': 'configuración de ruta',
      'supplier-billing':'factura',
      'supplier-payment-order': 'órden de pago',
    },
    entity: {
      bilingform_conciliation: 'Conciliaciones',
      bilingform_extracts: 'Extractos',
      billingform: 'Formulario de pago',
      child_entities: 'Hijos',
      sales: 'Ventas',
      otherModule: 'Otro módulo',
      config_application: 'Configuración de aplicaciones',
      'work-unit': 'Unidad de trabajo',
      'business-unit': 'Unidad de negocio',
      currency: 'Moneda',
      'document-type': 'Tipo de documento',
      'product-type': 'Tipo de producto',
      country: 'País',
      product: 'Producto',
      'business-type': 'Tipo de negocio',
      reservation: 'Reserva',
      'air-detail': 'Detalle de Aéreo',
      'hotel-detail': 'Detalle de Hoteles',
      user: 'Usuario',
      role: 'Rol',
      permission: 'Permisos',
      client: 'Cliente',
      application: 'Aplicación',
      process: 'Procesos por Módulo',
      processApplication: 'Procesos por Aplicación',
      module: 'Módulo',
      userByClientApp: 'Usuario de la aplicación-cliente',
      permissionByUser: 'Permisos del usuario',
      applicationByClient: 'Aplicación del cliente',
      permissionByRole: 'Permisos del rol',
      item: 'Elemento',
      supplier: 'Proveedor',
      contact: 'Contacto',
      roleByUser: 'Rol de usuario',
      'user-by-business-unit': 'Usuario por Unidad de Negocio',
      'product-work-unit-by-business-unit': 'Producto de Unidad de trabajo por Unidad de negocio',
      'car-detail': 'Detalle de auto',
      'user-by-work-unit': 'Usuario por Unidad de Trabajo',
      'currency-by-business-unit': 'Moneda por Unidad de Negocio',
      'currency-by-work-unit': 'Moneda por Unidad de Trabajo',
      pax: 'Pasajero',
      'fiscal-data': 'Información fiscal',
      'cancel-info': 'Información de cancelación',
      'cancel-info-item': 'Información de cancelación de reserva',
      'product-by-work-unit': 'Producto por Unidad de Trabajo',
      'pax-item': 'Pasajero de reserva',
      billing: 'Facturación',
      'business-rule': 'Reglas de negocio',
      entity: 'Entidad',
      installment: 'Financiación',
      card: 'Tarjetas',
      source: 'Fuente',
      bank: 'Banco',
      'payment-type': 'Tipo de pago',
      'payment-method': 'Método de pago',
      expenses: 'Gastos',
      'operation-type': 'Tipo de operación',
      cash: 'Caja',
      company: 'Compañía',
      'financial-entity': 'Entidad Financiera',
      versions: 'Versiones',
      'type-responsible': 'Tipo Responsable',
      numbering: 'Numeración',
      'payment-entity': 'Pagos',
      tag: 'Etiqueta',
      'banner-type': 'Tipo Banner',
      banner: 'Banner',
      'ext-train-marketing-carrier': 'Marketing Carrier',
      landing: 'Landing',
      userB2: 'Usuario',
      'formula-global-variables': 'Variables globales de formulas',
      'due-date-method': 'Modelo de vencimiento',
      'due-date-range': 'Calendario de vencimiento',
      financial_entity: 'Entidad financiera',
      'my-devices': 'Mis dispositivos',
      operation: 'Operaciones',
      'operation-bff': 'Operaciones BFF',
      'commerce-number': 'Nº de comercio',
      gateway: 'Pasarela de pago',
      notification: 'Notificaciones',
      'account-state': 'Estado de cuenta',
      reporting: 'Reportes',
    },
    field: {
      departure: 'Salida',
      arrival: 'Llegada',
      segment: 'Tramo',
      first_name: 'Nombre',
      last_name: 'Apellido',
      date_of_birth: 'Fecha de Nacimiento',
      doc_type: 'Tipo de Documento',
      doc_number: 'Número de Documento',
      country_of_residence: 'País de Residencia',
      email_address: 'Dirección de Email',
      extract_file: 'Archivo de extracto',
      reservations: 'Reservas',
      retentions: 'Retenciones',
      certificate: 'Certificado',
      coupon_number: 'Número de cupón',
      payers_document_number: 'Número de documento pagador',
      download_receipts: 'Descargar comprobantes',
      download_extract: 'Descargar extracto',
      observations: 'Observaciones',
      observations_internal: 'Observaciones internas',
      inputation_type: 'Tipo imputación',
      inputation_amount: 'Monto imputación',
      amount_aboned: 'Monto abonado',
      total_reservation: 'Total Reserva',
      select_all: 'todos...',
      created_until: 'Creado hasta',
      created_from: 'Creado desde',
      undefined: 'indefinido',
      reservations: 'Reservas',
      retentions: 'Retenciones',
      certificate: 'Certificado',
      payers_document_number: 'Número de documento pagador',
      download_receipts: 'Descargar comprobantes',
      download_extract: 'Descargar extracto',
      observations: 'Observaciones',
      observations_internal: 'Observaciones internas',
      inputation_type: 'Tipo imputación',
      inputation_amount: 'Monto imputación',
      amount_aboned: 'Monto abonado',
      total_reservation: 'Total Reserva',
      select_all: 'todos...',
      created_until: 'Creado hasta',
      created_from: 'Creado desde',
      undefined: 'indefinido',
      include: 'Incluir',
      exclude: 'Excluir',
      choices: 'Opciones',
      chosen: 'Elegidos',
      selected: 'seleccionados',
      status_flow: 'Estado del flujo',
      product: 'Producto',
      products: 'Productos',
      products_inheritance: 'Productos Heredados',
      products_inheritance_ut: 'Productos Heredados de Unidad de Trabajo',
      products_inheritance_un: 'Productos Heredados de Unidad de Negocios',
      dashboard: 'Tablero',
      is_offline: 'Es offline',
      children: 'Hijos',
      adults: 'Adultos',
      minors: 'Menores',
      layout: 'Plantilla',
      state: 'Estado',
      id: 'Id',
      token: 'Token',
      token_parent: 'Token Padre',
      email: 'Email',
      short_name: 'Nombre corto',
      long_name: 'Nombre largo',
      business_type: 'Tipo de negocio',
      business_type_id: 'Id de Tipo de negocio',
      name: 'Nombre',
      phone: 'Teléfono',
      phone_number: 'Número de teléfono',
      address: 'Dirección',
      region: 'Región',
      document_type: 'Tipo de documento',
      document_type_id: 'ID Tipo de documento',
      document_number: 'Número de documento',
      type_responsible: 'Tipo de responsable',
      manager_responsible: 'Responsable Operativo',
      commercial_responsible: 'Responsable Comercial',
      birthday: 'Fecha de Nacimiento',
      description: 'Descripción',
      item_description: 'Descripción del item',
      contact: 'Contacto',
      fantasy_name: 'Nombre de fantasía',
      date_out: 'Fecha de salida',
      date_in: 'Fecha de llegada',
      symbol: 'Símbolo',
      color: 'Color',
      ref_table_detail: 'Tabla de detalle',
      create_at: 'Creado',
      update_at: 'Actualizado',
      work_unit: 'Unidad de trabajo',
      work_unit_id: 'Id de Unidad de trabajo',
      business_unit: 'Unidad de negocio',
      firstname: 'Nombre',
      surname: 'Apellido',
      application: 'Aplicación',
      client: 'Cliente',
      role: 'Rol',
      hash_user: 'Hash de usuario',
      status: 'Estado',
      status_detail: 'Estado',
      action: 'Acción',
      module: 'Módulo',
      entity: 'Entidad',
      application_id: 'Id de Aplicación',
      start_icon: 'Icono inicial',
      permission: 'Permisos',
      menu: 'Menú',
      text: 'Texto',
      is_active: 'Activo',
      is_not_active: 'Inactivo',
      is_superadmin: 'Superadmin',
      is_staff: 'Staff',
      is_admin: 'Admin',
      module_id: 'Id de Módulo',
      client_id: 'Id de Cliente',
      product_json: 'Json de Productos',
      start_validity_rule: 'Inicio vigencia Regla',
      expiration: 'Expiración',
      config: 'Configuración',
      end_validity_rule: 'Fin vigencia Regla',
      username: 'Usuario',
      user_id: 'Id de Usuario',
      user: 'Usuario',
      password: 'Contraseña',
      value: 'Valor',
      tax_id: 'Identificador Impositivo',
      date_in_and_out: 'Fecha de salida y llegada',
      endpoint: 'Recurso',
      steps: 'Pasos',
      flight_number: 'Nro de vuelo',
      airline: 'Aerolínea',
      hotel: 'Hotel',
      item_id: 'Id de item',
      id_detail: 'Id del detalle',
      parameters: 'Parámetros',
      country_id: 'Id de País',
      country: 'País',
      city: 'Ciudad',
      currency: 'Moneda',
      currency_inheritance: 'Moneda heredada',
      code: 'Código',
      code_iata: 'Código IATA',
      tma_code: 'Código Facturación',
      days_to_cancel: 'Días para cancelar',
      autocancel: 'Autocancelación',
      external_code: 'Código externo',
      vat_active: 'Vat activo',
      gmx_contract_id: 'Id Contrato GMX',
      paste_json: 'Ingresar JSON',
      select_default_json: 'JSON predeterminado',
      write_json_manually: 'Escribir JSON manualmente',
      json: 'JSON',
      invalid_json: 'El JSON introducido no es válido',
      invalid_formulas: 'Las fórmulas introducidas no son válidas',
      tableName: 'tableName',
      api_endpoint: 'Api Endpoint',
      parent_workunit: 'Unidad de Trabajo - Padre',
      parent_businessunit: 'Unidad de Negocio - Padre',
      path: 'path',
      main: 'Principal',
      mapping: 'Mapeo',
      settings: 'Configuración',
      fiscal_data: 'Datos Fiscales',
      is_agency: 'Agencia',
      destination: 'Destino',
      destination_detail: 'Detalle destino',
      datetime_destination: 'Fecha y hora de destino',
      parent_businessRule: 'Regla de Negocio - Padre',
      rule_type: 'Tipo de regla',
      rule_liquidation_type: 'Tipo de regla de liquidación',
      destination_type: 'Tipo de destino',
      supplier: 'Proveedor',
      source: 'Fuente',
      payment: 'Pago',
      payments: 'Pagos',
      payment_types: 'Tipos de pago',
      payment_methods: 'Métodos de pago',
      payment_type: 'Tipo de pago',
      payment_method: 'Método de pago Tarjeta',
      payment_method_by_bank: 'Método de pago Banco',
      no_selected_var: 'No hay variables seleccionadas',
      operators: 'Operadores',
      data: 'Data',
      variables: 'Variables',
      create_formula: 'Crear fórmula',
      formula: 'Fórmula',
      show_breakdown: 'Mostrar en desglose',
      show_sitio: 'Mostrar en Sitio',
      checkin: 'Check-in',
      checkout: 'Check-out',
      concept: 'Concepto',
      amounts: 'Montos',
      amount: 'Importe Total',
      amount_pending: 'Importe Pendiente',
      id_item: 'Id de item',
      id_reserva: 'Id de Reserva',
      booking_number: 'Número reserva',
      item_number: 'Número item',
      amount_to_pay: 'Cantidad a pagar',
      date: 'Fecha',
      date_time: 'Fecha',
      auth_code: 'Autorización',
      card_number: 'Número de tarjeta',
      expiry_date: 'Fecha de Expiración',
      date_emision: 'Fecha de emisión',
      cardholder: 'Titular de la tarjeta',
      card_holder: 'Titular de Tarjeta',
      issuing_bank: 'Banco emisor',
      quota: 'Cantidad de cuotas',
      client_document_number: 'Número de documento cliente',
      client_name: 'Nombre cliente',
      bank: 'Banco',
      destinationBank: 'Banco destino',
      issuingBank: 'Banco emisor',
      coupon_number: 'Número de cupón',
      cash: 'Efectivo',
      type: 'Tipo',
      number: 'Número',
      initial_date: 'Fecha inicial',
      final_date: 'Fecha finalización',
      bank_name: 'Banco',
      refundable: 'Reembolsable',
      route: 'Ruta',
      reference: 'Referencia',
      gateway: 'Pasarela de pago',
      version_number: 'Número Version',
      modify_by: 'Modificado por',
      slug: 'Slug',
      account_number: 'Número de cuenta',
      parent_id: 'Id Padre',
      type_sum: 'Suma',
      financial_entity: 'Entidad financiera',
      card: 'Tarjeta',
      last_digit_card: 'Últimos 4 dígitos',
      reservation_item: 'items de la reserva',
      passenger: 'Pasajero',
      titular_passenger: 'Pasajero titular',
      seller: 'Vendedor',
      managerResponsible: 'Responsable operativo',
      operation_type: 'Tipo de operacion',
      operations: 'Operaciones',
      amount_to_use: 'Importe a utilizar',
      reserve: 'Reserva',
      document: 'Documento',
      age: 'Edad',
      birth_date: 'Fecha de nacimiento',
      is_titular: 'Es titular?',
      extra: 'extra',
      external_id: 'ID externo',
      gds: 'GDS',
      id_issue_office: 'Id de la oficina de emisión',
      transmitter: 'emisor',
      carryOnWeight: 'Peso CarryOn',
      handbag: 'bolso de mano',
      unit: 'Unidad',
      weight: 'Peso',
      operator_company: 'Compania operadora',
      booking_class: 'Clase',
      flight: 'Vuelo',
      equipmentType: 'Equipo',
      Cabin: 'Cabina',
      provider: 'Proveedor',
      provider_code: 'Código del proveedor',
      distribution: 'Distribución',
      type_room: 'Tipo de habitación',
      regime: 'Régimen',
      coverage: 'Cobertura',
      driver_name: 'Nombre del conductor',
      driver_lastname: 'Apellido del conductor',
      driver_document: 'Documento del conductor',
      driver_age: 'Edad del conductor',
      car_name: 'Nombre del auto',
      assistance_name: 'Nombre de la asistencia',
      origin: 'Origen',
      origin_detail: 'Detalle origen',
      datetime_origin: 'Fecha y hora de origen',
      operatingCarrier: 'Operating Carrier',
      marketingCarrier: 'Marketing Carrier',
      marketingInformation: 'Información de Marketing',
      business_name: 'Razón social',
      point_of_sale: 'Puntos de venta',
      segment_price: 'Tarifa tramo',
      booking_reference: 'Referencia de Reserva',
      hold_distributor: 'Fecha de Vencimiento',
      hash: 'Hash',
      priority: 'Prioridad',
      active_hours_to: 'Fin de hora de activación ',
      active_hours_from: 'Comienzo de hora de activación',
      active_days: 'Dias activos',
      start_reservation_date: 'Fecha de compra desde',
      end_reservation_date: 'Fecha de compra hasta',
      start_service_date: 'Fecha de inicio del servicio desde',
      end_service_date: 'Fecha de inicio del servicio hasta',
      numbering_client: 'Numeración Clientes',
      numbering_reservation: 'Numeración Reservas',
      file_number: 'Número de legajo',
      number_items: 'Número del item',
      locator: 'Localizador',
      total: 'Total',
      num_item_billing: 'Número Item Facturación',
      invoice: 'Factura',
      change_type: 'Tipo de cambio',
      change_type_reversed: 'Tipo de cambio invertido',
      receipt_number: 'Número Recibo',
      cash_name: 'Caja',
      client_document_type: 'Tipo de documento',
      origin_date: 'Fecha',
      vendor_code: 'Tarjeta de crédito',
      transaction: 'Transacción',
      comision: 'Comisión',
      commission_paid: 'Comisión cedida',
      expenses: 'Gastos Administrativos',
      fare_amount: 'Importe de la tarifa',
      fee: 'Fee',
      final_price: 'Precio venta',
      iva: 'Iva',
      markup: 'Markup',
      mark_up: 'Markup',
      net_agency: 'Precio neto Agencia',
      net_price: 'Precio neto',
      net_provider: 'Neto proveedor',
      over_amount: 'Over',
      taxes_amount: 'Impuestos',
      product_type: 'Tipo de producto',
      renter: 'Rentadora',
      date_origin_service: 'Inicio de servicio',
      date_destination_service: 'Finalización de servicio',
      pickup_origin: 'Origen',
      pickup_date: 'Fecha y Hora',
      pickup_type: 'Detalle Pick Up',
      pickup_destination: 'Destino',
      pickup_transfer_type: 'Tipo de Traslado',
      pickup_category: 'Categoría',
      pickup_vehicle: 'Tipo de Vehículo',
      pnr: 'Código PNR',
      days_number: 'Cantidad de días',
      donwload_voucher: 'Descarga voucher',
      commissionable_rate: 'Tarifa comisionable',
      non_commissionable_rate: 'Tarifa No Comisionable',
      commission_percentage: 'Porcentaje de comision',
      ancillary_pax_1: 'Costo ancillary baggage',
      additional_fare: 'Adicional a pagar en destino',
      net_price_by_car: 'Total costo proveedor',
      nationality: 'Nacionalidad',
      residence_country: 'País de residencia',
      receiver: 'Receptor',
      mail: 'Email',
      hashuser: 'Hash del usuario',
      hash_business_unit: 'Hash unidad de negocio',
      agency_id: 'Id de agencia',
      pick_up: 'Pick Up',
      drop_off: 'Drop Off',
      check_in_pick_up: 'Fecha Pick Up',
      check_in_drop_off: 'Fecha Drop Off',
      dropoff_type: 'Detalle Drop Off',
      created_at: 'Fecha de creación',
      updated_at: 'Fecha de actualización',
      reservation_number: 'Número de reserva',
      date_first_service: 'Fecha 1er servicio',
      start_date_first_service: 'Fecha 1er servicio desde',
      end_date_first_service: 'Fecha 1er servicio hasta',
      start_create_date: 'Fecha de creación desde',
      end_create_date: 'Fecha de creación hasta',
      start_autocancel_date: 'Fecha de autocancelación desde',
      end_autocancel_date: 'Fecha de autocancelación hasta',
      start_last_modification_date: 'Fecha de modificación desde',
      end_last_modification_date: 'Fecha de modificación hasta',
      search_client: 'Buscar cliente',
      search_reservation: 'Buscar reserva',
      add_tags: 'Agregar etiquetas al producto',
      round_trip: 'Toma y deja en el mismo lugar',
      add_transfer: '¿Sumar traslado?',
      detail_service: 'Detalle servicio',
      hash_booking_id: 'Hash/Booking ID',
      'product-type': 'Tipo de producto',
      validity: 'Validez',
      from: 'Desde',
      to: 'Hasta',
      rate_type: 'Tipo de tarifa',
      ticketNumber: 'Número de pase',
      period_type: 'Tipo de oferta',
      duration: 'Duración',
      sample: 'Muestra',
      offline_product: 'Admite carga Offline',
      prefix: 'Prefijo',
      document_branch_number: 'Número de sucursal',
      last_used: 'Último utilizado',
      payment_status: 'Estado del pago',
      reservation_status: 'Estado de la reserva',
      item_status: 'Estado de cada item',
      num_pax: 'Cantidad de pasajeros',
      num_segments: 'Cantidad de tramos',
      seat: 'Asientos',
      create_time: 'Fecha de creación',
      paypal_id: 'Id de paypal',
      payment_id: 'Id de pago',
      intent: 'Motivo',
      observation: 'Observación',
      origin_observation: 'Observación de origen',
      currency_to: 'Moneda hasta',
      currency_from: 'Moneda desde',
      available_credits: 'Créditos disponibles',
      credit_to_sum: 'Créditos a sumar',
      limit_credit: 'Límite de creditos',
      has_credit: 'Usa créditos',
      gmx_segment_id: 'Código Gimmonix',
      is_berlin: '¿Es berlin?',
      setting_email: 'Configuración email',
      logo: 'Logo',
      logo_voucher: 'Logo voucher',
      sale_number: 'Referencia Externa',
      autocancel_date: 'Fecha de autocancelación',
      primary_color: 'Primer color',
      secondary_color: 'Segundo color',
      folder_root: 'Carpeta raiz',
      bcc_email: 'BCC email',
      transport: 'Transport',
      mailer_from: 'Mailer from',
      mailer_host: 'Mailer host',
      mailer_user: 'Mailer user',
      mailer_password: 'Mailer password',
      mailer_port: 'Mailer port',
      use_tls: 'Usar tls',
      use_ssl: 'Usar ssl',
      header: 'Header',
      subject: 'Asunto',
      greeting: 'Greeting',
      content: 'Content',
      footer: 'Footer',
      hash_value: 'Hash',
      notification: 'Notificaciones',
      seller_user: 'Usuario vendedor',
      last_update_date: 'Fecha última modificación',
      tma_business: 'Negocio TMA',
      tags: 'Etiquetas',
      folder: 'Carpeta',
      billing_status: 'Estado de facturación',
      additional_cost: 'Costo adicional',
      total_cost: 'Costo Total',
      current_password: 'Contraseña actual',
      new_password: 'Nueva contraseña',
      confirm_new_password: 'Confirmar nueva contraseña',
      credit_or_payment_type: 'Credito o Tipo de pago',
      apply_extra_cost: 'Aplica Gastos',
      amount_in_currency_to_pay: 'Total en moneda de origen',
      currency_pay: 'Moneda de pago',
      total_amount_in_currency_to_pay: 'Total en moneda de pago',
      pending_amount_in_currency_to_pay: 'Pendiente de pago en moneda de Pago',
      amount_to_apply: 'Importe a aplicar',
      total_amount_billing: 'Total Venta',
      total_cost_billing: 'Total Costo',
      base: 'Tipo de cambio',
      profit_percentage: '% Beneficio',
      item_descripcion: 'Descripción del Item',
      amount_paid: 'Importe Aplicado',
      pending_amount: 'Pendiente de pago',
      have_credit: 'Posee crédito',
      amount_unused: 'Monto sin utilizar',
      e_ticket: 'E-Ticket',
      in_reserve: 'En reserva',
      marketing_carrier: 'Marketing carrier',
      addressee: 'Destinatario',
      email_sent: 'Email enviado',
      send_to: 'Enviar a',
      differentiated_change_type: 'Tipo de cambio diferenciado',
      invoice_reference: 'Referencia factura',
      receipt_reference: 'Referencia recibo',
      search_by: 'Buscar por:',
      type_of_service: 'Tipo de Servicio',
      condition: 'Condición',
      billing_base: 'Base Facturación',
      billing_default_base: 'Base Facturación por defecto',
      billing_alternate_base: 'Base/s Facturación alternativa/s',
      billing_date: 'Fecha facturacion',
      ticket_number: 'Nro de ticket',
      is_billable: 'Listo para facturar',
      auto_bill: 'Facturar automáticamente',
      final_sale: 'Total venta',
      size_width: 'Tamaño ancho (px)',
      size_height: 'Tamaño alto (px)',
      mobile_size_width: 'Tamaño ancho móvil (px)',
      mobile_size_height: 'Tamaño alto móvil (px)',
      title: 'Título',
      button_text: 'Texto botón',
      link_button: 'Link botón',
      group: 'Grupo',
      html_content_additional: 'Contenido HTML adicional',
      meta: 'Meta',
      link: 'Link',
      datetime_from: 'Fecha desde',
      datetime_to: 'Fecha hasta',
      html_content: 'Contenido HTML',
      flow: 'Flow',
      order: 'Orden',
      site_type: 'Tipo sitio',
      category: 'Categoría',
      banner_type: 'Tipo de banner',
      image: 'Imagen',
      mobile_image: 'Imagen móvil',
      banner: 'Banner',
      label: 'Etiqueta',
      caption: 'Caption',
      url: 'URL',
      base_to_billing: 'Base para facturación',
      menu_visible: 'Menú visible',
      form_visible: 'Formulario visible',
      newsletter_visible: 'Newsletter visible',
      default_form: 'Formulario por defecto',
      sector_type: 'Tipo de sector',
      banners: 'Banners',
      sector: 'Sector',
      html: 'HTML',
      setting_html: 'Configurar HTML',
      see_html: 'Ver HTML',
      billing: 'Facturación',
      landing: 'Landing',
      auto_billable: 'Facturación automática',
      amount_compensated: 'Importe a compensar en  %{currency}',
      start_billing_date: 'Fecha de facturación desde',
      end_billing_date: 'Fecha de facturación hasta',
      billing_date: 'Fecha de facturación',
      amount_pending_in: 'Importe Pendiente en %{currency}',
      amount_pending_to_pay_in: 'Importe Pendiente a pagar en %{currency}',
      liquidation_type: 'Tipo de liquidación',
      login_required: 'Login necesario',
      index_required: 'Indexar',
      payment_date: 'Fecha de Pago',
      apply_total_in_order: 'Aplicar por orden',
      apply_total_equitably: 'Aplicar equitativamente',
      work_unit_long_name: 'Nombre largo de la unidad de trabajo',
      work_unit_short_name: 'Nombre corto de la unidad de trabajo',
      billing_automatic: 'Facturación automática',
      create_at_date: 'Fecha de creación',
      formula_global_variables: 'Varibles globales',
      textColor: 'Color texto',
      backgroundColor: 'Color fondo',
      ticket_type: 'Tipo de ticket',
      check_type: 'Tipo de cheque',
      e_ticket: 'E-ticket',
      is_emd: 'Es EMD',
      sale_discount: 'Descuento de venta',
      taxes_1: 'Impuesto 1',
      taxes_2: 'Impuesto 2',
      taxes_3: 'Impuesto 3',
      cabotage: 'Cabotaje',
      fare_code: 'Tarifa Adicional',
      method_pay_uatp: 'UATP',
      complete_client_name: 'Nombre y Apellido del Titular de la tarjeta',
      agency_auth_code: 'Autorización',
      authorization_code: 'Código de Autorización',
      payment_id_braspag: 'Identificador en Braspag',
      braspag_id: 'Identificador Braspag',
      card_brand_id: 'Identificador Marca Tarjeta',
      customer_email: 'Correo del Cliente',
      customer_birth: 'Fecha de Nacimiento del Cliente',
      customer_street: 'Direccion del Cliente',
      customer_city: 'Ciudad del Cliente',
      customer_district: 'Distrito del Cliente',
      child: 'Niño',
      adult: 'Adulto',
      infant: 'Infante',
      due_date_final: 'Fecha prorrogada',
      days: 'Dias',
      'due-date-range': 'Calendario',
      date_ranges: 'Rango de fechas',
      determining_date: 'Fecha determinante',
      due_date_method: 'Modelo de fecha de vencimiendo',
      expirations: 'Vencimientos',
      start_due_date: 'Vencimiento de Pago desde',
      end_due_date: 'Vencimiento de Pago hasta',
      due_date: 'Vencimiento de Pago',
      language: 'Idioma',
      holder: 'Titular',
      passenger_type: 'Tipo Pasajero',
      paypal_create_time: 'Fecha de creacion',
      exclude_product: 'Excluir productos',
      price_logic: 'logica de precio',
      json_product: 'JSON DE PRODUCTOS',
      detail_table: 'TABLA DE DETALLES',
      customer_number: 'Altura',
      customer_state: 'Estado del cliente',
      customer_country: 'Pais del cliente',
      customer_zip_code: 'CEP del Cliente',
      customer_complement: 'Complementaria del Cliente',
      installments: 'Cuotas',
      card_brand_name: 'Tarjeta',
      applications: 'Aplicaciones',
      ref_site: 'Referencia para el sitio',
      item_billing_status: 'Estado de facturacion del item',
      status_fraud: 'Analisis Fraude',
      my_device_computer: 'ordenador',
      my_device_phone: 'teléfono',
      browser: 'Navegador',
      last_active: 'Última vez activo',
      unknown: 'Desconocido',
      tx_id: 'Transaccion',
      customer_document_type: 'Tipo de documento',
      customer_document_value: 'Número de documento',
      customer_name: 'Nombre',
      has_retention: 'Tiene Retención',
      retention_type: 'Tipo de Retención',
      retention_amount: 'Importe de la Retención',
      retention_certificate: 'Número de Certificado',
      amount_used: 'Importe utilizado',
      payer_CUITCUIL: 'CUIT/CUIL pagador',
      reservationNumber: 'N° de reserva',
      removeReservation: 'Quitar reserva',
      totalAmount: 'Monto total',
      paidAmount: 'Monto abonado',
      pendingAmount: 'Monto pendiente',
      paymentMethod: 'Forma de pago',
      amount: 'Monto',
      otherAmount: 'Otro monto',
      declaredTotal: 'Total declarado',
      selectedTotal: 'Total seleccionado',
      finalBalance: 'Saldo final',
      supplierCode: 'Cod. provee',
      month: 'Mes',
      currencyType: 'Tipo moneda',
      isInherited: 'Es heredado',
      allocation_message: 'Mensaje de imputación',
      operation_id: 'ID de la operación',
      general_state: 'Estado General',
      flow_status: 'Estado Flow',
      passenger_count: 'Cantidad de pasajeros',
      segment_count: 'Cantidad de tramos',
      provider_codes: 'Códigos de proveedor',
      carriers: 'Transportistas',
      operating_carrier: 'Transportista operador',
      marketing_carrier: 'Transportista comercial',
      pass_name: 'Producto',
      pass_validity: 'Validez',
      pass_duration: 'Duración',
      pass_offer_type: 'Tipo de Oferta',
      pass_marketing_carrier: 'Marketing Carrier',
      total_amount: 'Monto total',
      payment_attempts: 'Intentos de pago',
      card_brand: 'Marca de tarjeta',
      payment_gateway: 'Pasarela de pago',
      company: 'Compañía',
      commerce_number: 'Número de comercio',
      display: 'Display',
      terminal: 'Terminal',
      client_code: 'Codigo de cliente',
      pyment_attempts: 'Intentos de pago',
      error_detail: 'Detalle de error',
      error_code: 'Código de error',
      session_expired: 'Sesión expirada',
      fraud_id: 'ID fraude',
      emission_status: 'Estado emisión',
      abandon_instance: 'Instancia de abandono',
      fraud_detail: 'Detalle de fraude',
      route_type: 'Tipo de ruta',
      device: 'Dispositivo',
      start_validity: 'Inicio vigencia',
      end_validity: 'Fin vigencia',
      last_update: 'Última actualización',
      coef: 'Coeficiente',
      card_type: 'Tipo de tarjeta',
      include_route: 'Rutas incluidas',
      exclude_route: 'Rutas excluidas',
      exclude_airlines: 'Aerolíneas excluidas',
      only_airline: 'Aerolínea única',
      business: 'Comercio',
      site_label: 'Etiqueta sitio',
      expense: 'Gasto',
      unifyCoef: 'Unificar coeficiente',
      bines: 'Bines',
      cft: 'CFT',
      tea: 'TEA',
      refund: 'Reintegro',
      bonus: 'Bonificación',
      seat_selection: 'Selección de asiento',
      food: 'Comida',
      changes: 'Cambios',
      refoundable: 'Reembolso',
      all_devices: 'Dispositivos',
      meta_code: 'Meta code',
      meta_info: 'Metadata',
      medium: 'Medio',
      campaign: 'Campaña',
      sessid: 'Sessid',
      tcid: 'Tcid',
      term: 'Term',
      comments: 'Comentarios',
      message: 'Mensaje',
      amount_refunded: 'Penalidad del reembolso',
      accounting_config_code: 'Configuración contable',
      supplier_type: 'Tipo de proveedor',
      creation_user: 'Usuario de creación',
      assigned: 'Asignado',
      message_type:'Tipo de mensaje',
      for:'Para',
      follower: 'Seguidor',
      assign_item: 'Asignar item',
      task_role: 'Rol de la tarea',
      template:'Plantilla',
      created_until: 'Creado hasta',
      created_from: 'Creado desde',
      total_to_return: 'Importe a devolver',
      smartbookTitle: 'Smartbook',
      smartbookOriginalProvider: 'Proveedor original',
      smartbookJson: 'JSON del smartbook',
      reserve_nrf:'Reserva Non Ref',
      documents:'Documentos',
      charged:'Cobrado',
      credit_balance:'Saldo a favor',
      billable_exchange_rate:'Tipo de cambio facturable',
      retention:'Retención',
      bad_practice: 'Mala práctica',
      debit: 'Débito',
      transaction_date: 'Fecha del movimiento',
      parent_long_name: 'Nombre Largo del Padre',
      parent_short_name: 'Nombre Corto del Padre',
      parent_fiscal_data_name: 'Razon Social del Padre',
      online_payments: 'Pagos online',
      weekly_availability: 'Disponibilidad semanal',
      supplier_due_date:'Fecha de vencimiento del proveedor',
      aditional_recipients: 'Destinatarios adicionales',
      creator:'Creador',
      internal_code:'Codigo interno',
      subtype: 'Subtipo',
      date_type: 'Tipo de fechas',
      sending_frequency: 'Periodicidad del envío',
      analysis_period: 'Período de análisis',
      payment_due_date: 'Fecha de vencimiento de pago',
      first_service_date: 'Fecha de 1er servicio',
      recipients:'Destinatarios',
      frequency:'Frecuencia',
      frequencies:'Frecuencias',
      parent_long_name: 'Nombre Largo del Padre',
      parent_short_name: 'Nombre Corto del Padre',
      parent_fiscal_data_name: 'Razon Social del Padre',
      online_payments: 'Pagos online',
      weekly_availability: 'Disponibilidad semanal',
      supplier_due_date:'Fecha de vencimiento del proveedor',
      aditional_recipients: 'Destinatarios adicionales',
      creator:'Creador',
      flexi: 'Flexi',
      extra_baggage: 'Equipaje extra',
      internal_code:'Codigo interno',
      item_create_date:'Fecha de creación del item',
      reserve_create_date:'Fecha de creación de la reserva',
      custom:'Personalizado',
      overdue_balance:'Saldo vencido',
      balance_due: 'Saldo a vencer',
      item_ticket_number: 'N° de ticket aéreo',
      gateway_expenses:'Gastos pasarela',
      end_date: 'Fecha de finalización',
      receipt_generated: 'Recibo generado',
      form:'Formulario',
      interest_display:'Visualización de intereses',
      fraud_review: 'Revisión Fraude',
      rebooker:'Rebooker',
      disable_rebooker:'Rebooker deshabilitado',
      days_to_rebook:'Días para rebookear',
      markup_additional:'Markup adicional',
      currency_value:'Valor de la moneda',
      type_determination_date:'Tipo de fecha determinante',
    },
    backend_error: {
      not_credit: 'por Crédito Insuficiente',
    },
    tooltip: {
      change_status_to_cancel: 'Esta acción solo cambiara el estado a cancelado',
      change_status_to_invoiced: 'Esta acción solo cambiara el estado a emitido',
      separateReservationsForMultiSearch: 'Separe las reservas por comas para búsqueda múltiple',
      supplier_order_generation: 'Generación de Orden de pago Proveedor',
      gateway_installment: 'Pasarela a través de la cuál se procesará el pago a la compañía',
      site_label_installment: 'Utilizado para reflejar información relacionada a la finaciación del sitio',
      order_installment: 'Priorización de financiación en sitio',
      routes_installment: 'Utilizado para financiaciones aplicables sólo para rutas específicas. Utilizar códigos IATA separados entre sí por guion y coma sin espacio cuando sea más de una. Ejemplo: EZE-MAD,MAD-EZE',
      exclude_airlines_installment: 'Utilizado para excluir códigos de líneas aéreas específicas que no aplican para la financiación',
      only_airline_installment: 'Activar opción cuando la financiación aplique únicamente para vuelos operados por la línea aérea indicada en el campo "Compañía"',
      installments: 'Cantidad de cuotas exhibidas en el sitio.',
      installments_gateway: 'Cantidad de cuotas para procesamiento en la pasarela de pago.',
      coef_installment: 'El costo resultante de la aplicación de este coeficiente se traslada al cliente en el sitio.',
      expense_installment: 'Campo utilizado para calcular costo interno de la financiación se traslade o no al cliente.',
      unify_coef_installment: 'De activarse el costo de la financiación se mostrará en el sitio unificado dentro de Cargos, sino se desglosará en una línea aparte de Intereses en el detalle de precio.',
      bines_installment: 'En caso de que la financiación aplique únicamente para ciertos bines indicarlo en este capo separados por coma sin espacio.',
      cft_installment: 'Texto libre. Info para mostrar en el sito.',
      tea_installment: 'Texto libre. Info para mostrar en el sito.',
      refund_installment: 'Texto libre. Info para mostrar en el sito.',
    },
    language: {
      english: 'Ingles',
      spanish: 'Español',
      pt_br: 'Portugues (brasil)',
    },
    rule_type: {
      PRICE: 'Regla de Precio',
      LIQUIDATION: 'Regla de Liquidación',
      BILLING: 'Regla de Facturación',
      PAYMENT_CHARGE: 'Regla de Cobranzas',
      SETTING: 'Regla de Configuración',
      CONTENT: 'Regla de Contenido',
      PAYMENT_METHOD: 'Regla de Metodos de Pagos',
      INSTALLMENT: 'Regla de Financiación',
    },
    destination_type: {
      national: 'Nacional',
      international: 'Internacional'
    },
    card_type: {
      credito: 'Crédito',
      debito: 'Débito'
    },
    baggage_type: {
      small_baggage_title: 'Incluye una mochila o cartera',
      small_baggage_description: 'Debe caber debajo del asiento delantero.',
      medium_baggage_title: 'Incluye equipaje de mano',
      medium_baggage_description: 'Debe caber en el compartimiento superior del avión.',
      medium_baggage_not_included: 'No incluye equipaje de mano',
      large_baggage_not_included: 'No incluye equipaje para despachar',
      large_baggage_included: 'Incluye equipaje para despachar',
    }
  },
}

export default languageObj
